import './style.css';
import { unref as Ht, getCurrentScope as Cn, onScopeDispose as On, getCurrentInstance as bn, onMounted as be, nextTick as Rn, computed as _n, ref as _, watch as He, defineComponent as Ie, openBlock as K, createElementBlock as ue, normalizeClass as Ce, renderSlot as An, createBlock as Ne, withCtx as lt, createElementVNode as q, Fragment as je, renderList as Tn, toDisplayString as Mn, pushScopeId as ut, popScopeId as dt, createCommentVNode as de, createVNode as ke, onUnmounted as Bn, withDirectives as Pn, vShow as xn } from "vue";
function jt(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: zt } = Object.prototype, { getPrototypeOf: ft } = Object, pt = ((e) => (t) => {
  const r = zt.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), ye = (e) => (e = e.toLowerCase(), (t) => pt(t) === e), ze = (e) => (t) => typeof t === e, { isArray: Re } = Array, Me = ze("undefined");
function Dn(e) {
  return e !== null && !Me(e) && e.constructor !== null && !Me(e.constructor) && ge(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Wt = ye("ArrayBuffer");
function Ln(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Wt(e.buffer), t;
}
const Un = ze("string"), ge = ze("function"), Jt = ze("number"), mt = (e) => e !== null && typeof e == "object", Fn = (e) => e === !0 || e === !1, De = (e) => {
  if (pt(e) !== "object")
    return !1;
  const t = ft(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, qn = ye("Date"), $n = ye("File"), Gn = ye("Blob"), Vn = ye("FileList"), kn = (e) => mt(e) && ge(e.pipe), Kn = (e) => {
  const t = "[object FormData]";
  return e && (typeof FormData == "function" && e instanceof FormData || zt.call(e) === t || ge(e.toString) && e.toString() === t);
}, Yn = ye("URLSearchParams"), Hn = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Be(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let n, a;
  if (typeof e != "object" && (e = [e]), Re(e))
    for (n = 0, a = e.length; n < a; n++)
      t.call(null, e[n], n, e);
  else {
    const o = r ? Object.getOwnPropertyNames(e) : Object.keys(e), i = o.length;
    let c;
    for (n = 0; n < i; n++)
      c = o[n], t.call(null, e[c], c, e);
  }
}
function Zt(e, t) {
  t = t.toLowerCase();
  const r = Object.keys(e);
  let n = r.length, a;
  for (; n-- > 0; )
    if (a = r[n], t === a.toLowerCase())
      return a;
  return null;
}
const Xt = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), Qt = (e) => !Me(e) && e !== Xt;
function rt() {
  const { caseless: e } = Qt(this) && this || {}, t = {}, r = (n, a) => {
    const o = e && Zt(t, a) || a;
    De(t[o]) && De(n) ? t[o] = rt(t[o], n) : De(n) ? t[o] = rt({}, n) : Re(n) ? t[o] = n.slice() : t[o] = n;
  };
  for (let n = 0, a = arguments.length; n < a; n++)
    arguments[n] && Be(arguments[n], r);
  return t;
}
const jn = (e, t, r, { allOwnKeys: n } = {}) => (Be(t, (a, o) => {
  r && ge(a) ? e[o] = jt(a, r) : e[o] = a;
}, { allOwnKeys: n }), e), zn = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), Wn = (e, t, r, n) => {
  e.prototype = Object.create(t.prototype, n), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), r && Object.assign(e.prototype, r);
}, Jn = (e, t, r, n) => {
  let a, o, i;
  const c = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (a = Object.getOwnPropertyNames(e), o = a.length; o-- > 0; )
      i = a[o], (!n || n(i, e, t)) && !c[i] && (t[i] = e[i], c[i] = !0);
    e = r !== !1 && ft(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, Zn = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  const n = e.indexOf(t, r);
  return n !== -1 && n === r;
}, Xn = (e) => {
  if (!e)
    return null;
  if (Re(e))
    return e;
  let t = e.length;
  if (!Jt(t))
    return null;
  const r = new Array(t);
  for (; t-- > 0; )
    r[t] = e[t];
  return r;
}, Qn = ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && ft(Uint8Array)), er = (e, t) => {
  const n = (e && e[Symbol.iterator]).call(e);
  let a;
  for (; (a = n.next()) && !a.done; ) {
    const o = a.value;
    t.call(e, o[0], o[1]);
  }
}, tr = (e, t) => {
  let r;
  const n = [];
  for (; (r = e.exec(t)) !== null; )
    n.push(r);
  return n;
}, nr = ye("HTMLFormElement"), rr = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, n, a) {
    return n.toUpperCase() + a;
  }
), bt = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), ar = ye("RegExp"), en = (e, t) => {
  const r = Object.getOwnPropertyDescriptors(e), n = {};
  Be(r, (a, o) => {
    t(a, o, e) !== !1 && (n[o] = a);
  }), Object.defineProperties(e, n);
}, or = (e) => {
  en(e, (t, r) => {
    if (ge(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const n = e[r];
    if (ge(n)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, ir = (e, t) => {
  const r = {}, n = (a) => {
    a.forEach((o) => {
      r[o] = !0;
    });
  };
  return Re(e) ? n(e) : n(String(e).split(t)), r;
}, sr = () => {
}, cr = (e, t) => (e = +e, Number.isFinite(e) ? e : t), Xe = "abcdefghijklmnopqrstuvwxyz", Rt = "0123456789", tn = {
  DIGIT: Rt,
  ALPHA: Xe,
  ALPHA_DIGIT: Xe + Xe.toUpperCase() + Rt
}, lr = (e = 16, t = tn.ALPHA_DIGIT) => {
  let r = "";
  const { length: n } = t;
  for (; e--; )
    r += t[Math.random() * n | 0];
  return r;
};
function ur(e) {
  return !!(e && ge(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const dr = (e) => {
  const t = new Array(10), r = (n, a) => {
    if (mt(n)) {
      if (t.indexOf(n) >= 0)
        return;
      if (!("toJSON" in n)) {
        t[a] = n;
        const o = Re(n) ? [] : {};
        return Be(n, (i, c) => {
          const u = r(i, a + 1);
          !Me(u) && (o[c] = u);
        }), t[a] = void 0, o;
      }
    }
    return n;
  };
  return r(e, 0);
}, l = {
  isArray: Re,
  isArrayBuffer: Wt,
  isBuffer: Dn,
  isFormData: Kn,
  isArrayBufferView: Ln,
  isString: Un,
  isNumber: Jt,
  isBoolean: Fn,
  isObject: mt,
  isPlainObject: De,
  isUndefined: Me,
  isDate: qn,
  isFile: $n,
  isBlob: Gn,
  isRegExp: ar,
  isFunction: ge,
  isStream: kn,
  isURLSearchParams: Yn,
  isTypedArray: Qn,
  isFileList: Vn,
  forEach: Be,
  merge: rt,
  extend: jn,
  trim: Hn,
  stripBOM: zn,
  inherits: Wn,
  toFlatObject: Jn,
  kindOf: pt,
  kindOfTest: ye,
  endsWith: Zn,
  toArray: Xn,
  forEachEntry: er,
  matchAll: tr,
  isHTMLForm: nr,
  hasOwnProperty: bt,
  hasOwnProp: bt,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: en,
  freezeMethods: or,
  toObjectSet: ir,
  toCamelCase: rr,
  noop: sr,
  toFiniteNumber: cr,
  findKey: Zt,
  global: Xt,
  isContextDefined: Qt,
  ALPHABET: tn,
  generateString: lr,
  isSpecCompliantForm: ur,
  toJSONObject: dr
};
function P(e, t, r, n, a) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), r && (this.config = r), n && (this.request = n), a && (this.response = a);
}
l.inherits(P, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: l.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const nn = P.prototype, rn = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  rn[e] = { value: e };
});
Object.defineProperties(P, rn);
Object.defineProperty(nn, "isAxiosError", { value: !0 });
P.from = (e, t, r, n, a, o) => {
  const i = Object.create(nn);
  return l.toFlatObject(e, i, function(u) {
    return u !== Error.prototype;
  }, (c) => c !== "isAxiosError"), P.call(i, e.message, t, r, n, a), i.cause = e, i.name = e.name, o && Object.assign(i, o), i;
};
const fr = null;
function at(e) {
  return l.isPlainObject(e) || l.isArray(e);
}
function an(e) {
  return l.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function _t(e, t, r) {
  return e ? e.concat(t).map(function(a, o) {
    return a = an(a), !r && o ? "[" + a + "]" : a;
  }).join(r ? "." : "") : t;
}
function pr(e) {
  return l.isArray(e) && !e.some(at);
}
const mr = l.toFlatObject(l, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function We(e, t, r) {
  if (!l.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), r = l.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(I, H) {
    return !l.isUndefined(H[I]);
  });
  const n = r.metaTokens, a = r.visitor || f, o = r.dots, i = r.indexes, u = (r.Blob || typeof Blob < "u" && Blob) && l.isSpecCompliantForm(t);
  if (!l.isFunction(a))
    throw new TypeError("visitor must be a function");
  function s(m) {
    if (m === null)
      return "";
    if (l.isDate(m))
      return m.toISOString();
    if (!u && l.isBlob(m))
      throw new P("Blob is not supported. Use a Buffer instead.");
    return l.isArrayBuffer(m) || l.isTypedArray(m) ? u && typeof Blob == "function" ? new Blob([m]) : Buffer.from(m) : m;
  }
  function f(m, I, H) {
    let N = m;
    if (m && !H && typeof m == "object") {
      if (l.endsWith(I, "{}"))
        I = n ? I : I.slice(0, -2), m = JSON.stringify(m);
      else if (l.isArray(m) && pr(m) || (l.isFileList(m) || l.endsWith(I, "[]")) && (N = l.toArray(m)))
        return I = an(I), N.forEach(function(x, k) {
          !(l.isUndefined(x) || x === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? _t([I], k, o) : i === null ? I : I + "[]",
            s(x)
          );
        }), !1;
    }
    return at(m) ? !0 : (t.append(_t(H, I, o), s(m)), !1);
  }
  const d = [], O = Object.assign(mr, {
    defaultVisitor: f,
    convertValue: s,
    isVisitable: at
  });
  function b(m, I) {
    if (!l.isUndefined(m)) {
      if (d.indexOf(m) !== -1)
        throw Error("Circular reference detected in " + I.join("."));
      d.push(m), l.forEach(m, function(N, R) {
        (!(l.isUndefined(N) || N === null) && a.call(
          t,
          N,
          l.isString(R) ? R.trim() : R,
          I,
          O
        )) === !0 && b(N, I ? I.concat(R) : [R]);
      }), d.pop();
    }
  }
  if (!l.isObject(e))
    throw new TypeError("data must be an object");
  return b(e), t;
}
function At(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function ht(e, t) {
  this._pairs = [], e && We(e, this, t);
}
const on = ht.prototype;
on.append = function(t, r) {
  this._pairs.push([t, r]);
};
on.toString = function(t) {
  const r = t ? function(n) {
    return t.call(this, n, At);
  } : At;
  return this._pairs.map(function(a) {
    return r(a[0]) + "=" + r(a[1]);
  }, "").join("&");
};
function hr(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function sn(e, t, r) {
  if (!t)
    return e;
  const n = r && r.encode || hr, a = r && r.serialize;
  let o;
  if (a ? o = a(t, r) : o = l.isURLSearchParams(t) ? t.toString() : new ht(t, r).toString(n), o) {
    const i = e.indexOf("#");
    i !== -1 && (e = e.slice(0, i)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return e;
}
class yr {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, r, n) {
    return this.handlers.push({
      fulfilled: t,
      rejected: r,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    l.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
}
const Tt = yr, cn = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Er = typeof URLSearchParams < "u" ? URLSearchParams : ht, vr = typeof FormData < "u" ? FormData : null, gr = typeof Blob < "u" ? Blob : null, Nr = (() => {
  let e;
  return typeof navigator < "u" && ((e = navigator.product) === "ReactNative" || e === "NativeScript" || e === "NS") ? !1 : typeof window < "u" && typeof document < "u";
})(), Ir = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), me = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Er,
    FormData: vr,
    Blob: gr
  },
  isStandardBrowserEnv: Nr,
  isStandardBrowserWebWorkerEnv: Ir,
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
function Sr(e, t) {
  return We(e, new me.classes.URLSearchParams(), Object.assign({
    visitor: function(r, n, a, o) {
      return me.isNode && l.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function wr(e) {
  return l.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function Cr(e) {
  const t = {}, r = Object.keys(e);
  let n;
  const a = r.length;
  let o;
  for (n = 0; n < a; n++)
    o = r[n], t[o] = e[o];
  return t;
}
function ln(e) {
  function t(r, n, a, o) {
    let i = r[o++];
    const c = Number.isFinite(+i), u = o >= r.length;
    return i = !i && l.isArray(a) ? a.length : i, u ? (l.hasOwnProp(a, i) ? a[i] = [a[i], n] : a[i] = n, !c) : ((!a[i] || !l.isObject(a[i])) && (a[i] = []), t(r, n, a[i], o) && l.isArray(a[i]) && (a[i] = Cr(a[i])), !c);
  }
  if (l.isFormData(e) && l.isFunction(e.entries)) {
    const r = {};
    return l.forEachEntry(e, (n, a) => {
      t(wr(n), a, r, 0);
    }), r;
  }
  return null;
}
const Or = {
  "Content-Type": void 0
};
function br(e, t, r) {
  if (l.isString(e))
    try {
      return (t || JSON.parse)(e), l.trim(e);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (r || JSON.stringify)(e);
}
const Je = {
  transitional: cn,
  adapter: ["xhr", "http"],
  transformRequest: [function(t, r) {
    const n = r.getContentType() || "", a = n.indexOf("application/json") > -1, o = l.isObject(t);
    if (o && l.isHTMLForm(t) && (t = new FormData(t)), l.isFormData(t))
      return a && a ? JSON.stringify(ln(t)) : t;
    if (l.isArrayBuffer(t) || l.isBuffer(t) || l.isStream(t) || l.isFile(t) || l.isBlob(t))
      return t;
    if (l.isArrayBufferView(t))
      return t.buffer;
    if (l.isURLSearchParams(t))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let c;
    if (o) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return Sr(t, this.formSerializer).toString();
      if ((c = l.isFileList(t)) || n.indexOf("multipart/form-data") > -1) {
        const u = this.env && this.env.FormData;
        return We(
          c ? { "files[]": t } : t,
          u && new u(),
          this.formSerializer
        );
      }
    }
    return o || a ? (r.setContentType("application/json", !1), br(t)) : t;
  }],
  transformResponse: [function(t) {
    const r = this.transitional || Je.transitional, n = r && r.forcedJSONParsing, a = this.responseType === "json";
    if (t && l.isString(t) && (n && !this.responseType || a)) {
      const i = !(r && r.silentJSONParsing) && a;
      try {
        return JSON.parse(t);
      } catch (c) {
        if (i)
          throw c.name === "SyntaxError" ? P.from(c, P.ERR_BAD_RESPONSE, this, null, this.response) : c;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: me.classes.FormData,
    Blob: me.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
l.forEach(["delete", "get", "head"], function(t) {
  Je.headers[t] = {};
});
l.forEach(["post", "put", "patch"], function(t) {
  Je.headers[t] = l.merge(Or);
});
const yt = Je, Rr = l.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), _r = (e) => {
  const t = {};
  let r, n, a;
  return e && e.split(`
`).forEach(function(i) {
    a = i.indexOf(":"), r = i.substring(0, a).trim().toLowerCase(), n = i.substring(a + 1).trim(), !(!r || t[r] && Rr[r]) && (r === "set-cookie" ? t[r] ? t[r].push(n) : t[r] = [n] : t[r] = t[r] ? t[r] + ", " + n : n);
  }), t;
}, Mt = Symbol("internals");
function Te(e) {
  return e && String(e).trim().toLowerCase();
}
function Le(e) {
  return e === !1 || e == null ? e : l.isArray(e) ? e.map(Le) : String(e);
}
function Ar(e) {
  const t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = r.exec(e); )
    t[n[1]] = n[2];
  return t;
}
function Tr(e) {
  return /^[-_a-zA-Z]+$/.test(e.trim());
}
function Qe(e, t, r, n, a) {
  if (l.isFunction(n))
    return n.call(this, t, r);
  if (a && (t = r), !!l.isString(t)) {
    if (l.isString(n))
      return t.indexOf(n) !== -1;
    if (l.isRegExp(n))
      return n.test(t);
  }
}
function Mr(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, n) => r.toUpperCase() + n);
}
function Br(e, t) {
  const r = l.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(e, n + r, {
      value: function(a, o, i) {
        return this[n].call(this, t, a, o, i);
      },
      configurable: !0
    });
  });
}
class Ze {
  constructor(t) {
    t && this.set(t);
  }
  set(t, r, n) {
    const a = this;
    function o(c, u, s) {
      const f = Te(u);
      if (!f)
        throw new Error("header name must be a non-empty string");
      const d = l.findKey(a, f);
      (!d || a[d] === void 0 || s === !0 || s === void 0 && a[d] !== !1) && (a[d || u] = Le(c));
    }
    const i = (c, u) => l.forEach(c, (s, f) => o(s, f, u));
    return l.isPlainObject(t) || t instanceof this.constructor ? i(t, r) : l.isString(t) && (t = t.trim()) && !Tr(t) ? i(_r(t), r) : t != null && o(r, t, n), this;
  }
  get(t, r) {
    if (t = Te(t), t) {
      const n = l.findKey(this, t);
      if (n) {
        const a = this[n];
        if (!r)
          return a;
        if (r === !0)
          return Ar(a);
        if (l.isFunction(r))
          return r.call(this, a, n);
        if (l.isRegExp(r))
          return r.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, r) {
    if (t = Te(t), t) {
      const n = l.findKey(this, t);
      return !!(n && this[n] !== void 0 && (!r || Qe(this, this[n], n, r)));
    }
    return !1;
  }
  delete(t, r) {
    const n = this;
    let a = !1;
    function o(i) {
      if (i = Te(i), i) {
        const c = l.findKey(n, i);
        c && (!r || Qe(n, n[c], c, r)) && (delete n[c], a = !0);
      }
    }
    return l.isArray(t) ? t.forEach(o) : o(t), a;
  }
  clear(t) {
    const r = Object.keys(this);
    let n = r.length, a = !1;
    for (; n--; ) {
      const o = r[n];
      (!t || Qe(this, this[o], o, t, !0)) && (delete this[o], a = !0);
    }
    return a;
  }
  normalize(t) {
    const r = this, n = {};
    return l.forEach(this, (a, o) => {
      const i = l.findKey(n, o);
      if (i) {
        r[i] = Le(a), delete r[o];
        return;
      }
      const c = t ? Mr(o) : String(o).trim();
      c !== o && delete r[o], r[c] = Le(a), n[c] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const r = /* @__PURE__ */ Object.create(null);
    return l.forEach(this, (n, a) => {
      n != null && n !== !1 && (r[a] = t && l.isArray(n) ? n.join(", ") : n);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, r]) => t + ": " + r).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...r) {
    const n = new this(t);
    return r.forEach((a) => n.set(a)), n;
  }
  static accessor(t) {
    const n = (this[Mt] = this[Mt] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function o(i) {
      const c = Te(i);
      n[c] || (Br(a, i), n[c] = !0);
    }
    return l.isArray(t) ? t.forEach(o) : o(t), this;
  }
}
Ze.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
l.freezeMethods(Ze.prototype);
l.freezeMethods(Ze);
const he = Ze;
function et(e, t) {
  const r = this || yt, n = t || r, a = he.from(n.headers);
  let o = n.data;
  return l.forEach(e, function(c) {
    o = c.call(r, o, a.normalize(), t ? t.status : void 0);
  }), a.normalize(), o;
}
function un(e) {
  return !!(e && e.__CANCEL__);
}
function Pe(e, t, r) {
  P.call(this, e ?? "canceled", P.ERR_CANCELED, t, r), this.name = "CanceledError";
}
l.inherits(Pe, P, {
  __CANCEL__: !0
});
function Pr(e, t, r) {
  const n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? e(r) : t(new P(
    "Request failed with status code " + r.status,
    [P.ERR_BAD_REQUEST, P.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
const xr = me.isStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  function() {
    return {
      write: function(r, n, a, o, i, c) {
        const u = [];
        u.push(r + "=" + encodeURIComponent(n)), l.isNumber(a) && u.push("expires=" + new Date(a).toGMTString()), l.isString(o) && u.push("path=" + o), l.isString(i) && u.push("domain=" + i), c === !0 && u.push("secure"), document.cookie = u.join("; ");
      },
      read: function(r) {
        const n = document.cookie.match(new RegExp("(^|;\\s*)(" + r + ")=([^;]*)"));
        return n ? decodeURIComponent(n[3]) : null;
      },
      remove: function(r) {
        this.write(r, "", Date.now() - 864e5);
      }
    };
  }()
) : (
  // Non standard browser env (web workers, react-native) lack needed support.
  function() {
    return {
      write: function() {
      },
      read: function() {
        return null;
      },
      remove: function() {
      }
    };
  }()
);
function Dr(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function Lr(e, t) {
  return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function dn(e, t) {
  return e && !Dr(t) ? Lr(e, t) : t;
}
const Ur = me.isStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = /(msie|trident)/i.test(navigator.userAgent), r = document.createElement("a");
    let n;
    function a(o) {
      let i = o;
      return t && (r.setAttribute("href", i), i = r.href), r.setAttribute("href", i), {
        href: r.href,
        protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
        host: r.host,
        search: r.search ? r.search.replace(/^\?/, "") : "",
        hash: r.hash ? r.hash.replace(/^#/, "") : "",
        hostname: r.hostname,
        port: r.port,
        pathname: r.pathname.charAt(0) === "/" ? r.pathname : "/" + r.pathname
      };
    }
    return n = a(window.location.href), function(i) {
      const c = l.isString(i) ? a(i) : i;
      return c.protocol === n.protocol && c.host === n.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  function() {
    return function() {
      return !0;
    };
  }()
);
function Fr(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function qr(e, t) {
  e = e || 10;
  const r = new Array(e), n = new Array(e);
  let a = 0, o = 0, i;
  return t = t !== void 0 ? t : 1e3, function(u) {
    const s = Date.now(), f = n[o];
    i || (i = s), r[a] = u, n[a] = s;
    let d = o, O = 0;
    for (; d !== a; )
      O += r[d++], d = d % e;
    if (a = (a + 1) % e, a === o && (o = (o + 1) % e), s - i < t)
      return;
    const b = f && s - f;
    return b ? Math.round(O * 1e3 / b) : void 0;
  };
}
function Bt(e, t) {
  let r = 0;
  const n = qr(50, 250);
  return (a) => {
    const o = a.loaded, i = a.lengthComputable ? a.total : void 0, c = o - r, u = n(c), s = o <= i;
    r = o;
    const f = {
      loaded: o,
      total: i,
      progress: i ? o / i : void 0,
      bytes: c,
      rate: u || void 0,
      estimated: u && i && s ? (i - o) / u : void 0,
      event: a
    };
    f[t ? "download" : "upload"] = !0, e(f);
  };
}
const $r = typeof XMLHttpRequest < "u", Gr = $r && function(e) {
  return new Promise(function(r, n) {
    let a = e.data;
    const o = he.from(e.headers).normalize(), i = e.responseType;
    let c;
    function u() {
      e.cancelToken && e.cancelToken.unsubscribe(c), e.signal && e.signal.removeEventListener("abort", c);
    }
    l.isFormData(a) && (me.isStandardBrowserEnv || me.isStandardBrowserWebWorkerEnv) && o.setContentType(!1);
    let s = new XMLHttpRequest();
    if (e.auth) {
      const b = e.auth.username || "", m = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
      o.set("Authorization", "Basic " + btoa(b + ":" + m));
    }
    const f = dn(e.baseURL, e.url);
    s.open(e.method.toUpperCase(), sn(f, e.params, e.paramsSerializer), !0), s.timeout = e.timeout;
    function d() {
      if (!s)
        return;
      const b = he.from(
        "getAllResponseHeaders" in s && s.getAllResponseHeaders()
      ), I = {
        data: !i || i === "text" || i === "json" ? s.responseText : s.response,
        status: s.status,
        statusText: s.statusText,
        headers: b,
        config: e,
        request: s
      };
      Pr(function(N) {
        r(N), u();
      }, function(N) {
        n(N), u();
      }, I), s = null;
    }
    if ("onloadend" in s ? s.onloadend = d : s.onreadystatechange = function() {
      !s || s.readyState !== 4 || s.status === 0 && !(s.responseURL && s.responseURL.indexOf("file:") === 0) || setTimeout(d);
    }, s.onabort = function() {
      s && (n(new P("Request aborted", P.ECONNABORTED, e, s)), s = null);
    }, s.onerror = function() {
      n(new P("Network Error", P.ERR_NETWORK, e, s)), s = null;
    }, s.ontimeout = function() {
      let m = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded";
      const I = e.transitional || cn;
      e.timeoutErrorMessage && (m = e.timeoutErrorMessage), n(new P(
        m,
        I.clarifyTimeoutError ? P.ETIMEDOUT : P.ECONNABORTED,
        e,
        s
      )), s = null;
    }, me.isStandardBrowserEnv) {
      const b = (e.withCredentials || Ur(f)) && e.xsrfCookieName && xr.read(e.xsrfCookieName);
      b && o.set(e.xsrfHeaderName, b);
    }
    a === void 0 && o.setContentType(null), "setRequestHeader" in s && l.forEach(o.toJSON(), function(m, I) {
      s.setRequestHeader(I, m);
    }), l.isUndefined(e.withCredentials) || (s.withCredentials = !!e.withCredentials), i && i !== "json" && (s.responseType = e.responseType), typeof e.onDownloadProgress == "function" && s.addEventListener("progress", Bt(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && s.upload && s.upload.addEventListener("progress", Bt(e.onUploadProgress)), (e.cancelToken || e.signal) && (c = (b) => {
      s && (n(!b || b.type ? new Pe(null, e, s) : b), s.abort(), s = null);
    }, e.cancelToken && e.cancelToken.subscribe(c), e.signal && (e.signal.aborted ? c() : e.signal.addEventListener("abort", c)));
    const O = Fr(f);
    if (O && me.protocols.indexOf(O) === -1) {
      n(new P("Unsupported protocol " + O + ":", P.ERR_BAD_REQUEST, e));
      return;
    }
    s.send(a || null);
  });
}, Ue = {
  http: fr,
  xhr: Gr
};
l.forEach(Ue, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Vr = {
  getAdapter: (e) => {
    e = l.isArray(e) ? e : [e];
    const { length: t } = e;
    let r, n;
    for (let a = 0; a < t && (r = e[a], !(n = l.isString(r) ? Ue[r.toLowerCase()] : r)); a++)
      ;
    if (!n)
      throw n === !1 ? new P(
        `Adapter ${r} is not supported by the environment`,
        "ERR_NOT_SUPPORT"
      ) : new Error(
        l.hasOwnProp(Ue, r) ? `Adapter '${r}' is not available in the build` : `Unknown adapter '${r}'`
      );
    if (!l.isFunction(n))
      throw new TypeError("adapter is not a function");
    return n;
  },
  adapters: Ue
};
function tt(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Pe(null, e);
}
function Pt(e) {
  return tt(e), e.headers = he.from(e.headers), e.data = et.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Vr.getAdapter(e.adapter || yt.adapter)(e).then(function(n) {
    return tt(e), n.data = et.call(
      e,
      e.transformResponse,
      n
    ), n.headers = he.from(n.headers), n;
  }, function(n) {
    return un(n) || (tt(e), n && n.response && (n.response.data = et.call(
      e,
      e.transformResponse,
      n.response
    ), n.response.headers = he.from(n.response.headers))), Promise.reject(n);
  });
}
const xt = (e) => e instanceof he ? e.toJSON() : e;
function Oe(e, t) {
  t = t || {};
  const r = {};
  function n(s, f, d) {
    return l.isPlainObject(s) && l.isPlainObject(f) ? l.merge.call({ caseless: d }, s, f) : l.isPlainObject(f) ? l.merge({}, f) : l.isArray(f) ? f.slice() : f;
  }
  function a(s, f, d) {
    if (l.isUndefined(f)) {
      if (!l.isUndefined(s))
        return n(void 0, s, d);
    } else
      return n(s, f, d);
  }
  function o(s, f) {
    if (!l.isUndefined(f))
      return n(void 0, f);
  }
  function i(s, f) {
    if (l.isUndefined(f)) {
      if (!l.isUndefined(s))
        return n(void 0, s);
    } else
      return n(void 0, f);
  }
  function c(s, f, d) {
    if (d in t)
      return n(s, f);
    if (d in e)
      return n(void 0, s);
  }
  const u = {
    url: o,
    method: o,
    data: o,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: c,
    headers: (s, f) => a(xt(s), xt(f), !0)
  };
  return l.forEach(Object.keys(e).concat(Object.keys(t)), function(f) {
    const d = u[f] || a, O = d(e[f], t[f], f);
    l.isUndefined(O) && d !== c || (r[f] = O);
  }), r;
}
const fn = "1.3.4", Et = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Et[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Dt = {};
Et.transitional = function(t, r, n) {
  function a(o, i) {
    return "[Axios v" + fn + "] Transitional option '" + o + "'" + i + (n ? ". " + n : "");
  }
  return (o, i, c) => {
    if (t === !1)
      throw new P(
        a(i, " has been removed" + (r ? " in " + r : "")),
        P.ERR_DEPRECATED
      );
    return r && !Dt[i] && (Dt[i] = !0, console.warn(
      a(
        i,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), t ? t(o, i, c) : !0;
  };
};
function kr(e, t, r) {
  if (typeof e != "object")
    throw new P("options must be an object", P.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(e);
  let a = n.length;
  for (; a-- > 0; ) {
    const o = n[a], i = t[o];
    if (i) {
      const c = e[o], u = c === void 0 || i(c, o, e);
      if (u !== !0)
        throw new P("option " + o + " must be " + u, P.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new P("Unknown option " + o, P.ERR_BAD_OPTION);
  }
}
const ot = {
  assertOptions: kr,
  validators: Et
}, ve = ot.validators;
class Ke {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new Tt(),
      response: new Tt()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(t, r) {
    typeof t == "string" ? (r = r || {}, r.url = t) : r = t || {}, r = Oe(this.defaults, r);
    const { transitional: n, paramsSerializer: a, headers: o } = r;
    n !== void 0 && ot.assertOptions(n, {
      silentJSONParsing: ve.transitional(ve.boolean),
      forcedJSONParsing: ve.transitional(ve.boolean),
      clarifyTimeoutError: ve.transitional(ve.boolean)
    }, !1), a !== void 0 && ot.assertOptions(a, {
      encode: ve.function,
      serialize: ve.function
    }, !0), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let i;
    i = o && l.merge(
      o.common,
      o[r.method]
    ), i && l.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (m) => {
        delete o[m];
      }
    ), r.headers = he.concat(i, o);
    const c = [];
    let u = !0;
    this.interceptors.request.forEach(function(I) {
      typeof I.runWhen == "function" && I.runWhen(r) === !1 || (u = u && I.synchronous, c.unshift(I.fulfilled, I.rejected));
    });
    const s = [];
    this.interceptors.response.forEach(function(I) {
      s.push(I.fulfilled, I.rejected);
    });
    let f, d = 0, O;
    if (!u) {
      const m = [Pt.bind(this), void 0];
      for (m.unshift.apply(m, c), m.push.apply(m, s), O = m.length, f = Promise.resolve(r); d < O; )
        f = f.then(m[d++], m[d++]);
      return f;
    }
    O = c.length;
    let b = r;
    for (d = 0; d < O; ) {
      const m = c[d++], I = c[d++];
      try {
        b = m(b);
      } catch (H) {
        I.call(this, H);
        break;
      }
    }
    try {
      f = Pt.call(this, b);
    } catch (m) {
      return Promise.reject(m);
    }
    for (d = 0, O = s.length; d < O; )
      f = f.then(s[d++], s[d++]);
    return f;
  }
  getUri(t) {
    t = Oe(this.defaults, t);
    const r = dn(t.baseURL, t.url);
    return sn(r, t.params, t.paramsSerializer);
  }
}
l.forEach(["delete", "get", "head", "options"], function(t) {
  Ke.prototype[t] = function(r, n) {
    return this.request(Oe(n || {}, {
      method: t,
      url: r,
      data: (n || {}).data
    }));
  };
});
l.forEach(["post", "put", "patch"], function(t) {
  function r(n) {
    return function(o, i, c) {
      return this.request(Oe(c || {}, {
        method: t,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: i
      }));
    };
  }
  Ke.prototype[t] = r(), Ke.prototype[t + "Form"] = r(!0);
});
const Fe = Ke;
class vt {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(o) {
      r = o;
    });
    const n = this;
    this.promise.then((a) => {
      if (!n._listeners)
        return;
      let o = n._listeners.length;
      for (; o-- > 0; )
        n._listeners[o](a);
      n._listeners = null;
    }), this.promise.then = (a) => {
      let o;
      const i = new Promise((c) => {
        n.subscribe(c), o = c;
      }).then(a);
      return i.cancel = function() {
        n.unsubscribe(o);
      }, i;
    }, t(function(o, i, c) {
      n.reason || (n.reason = new Pe(o, i, c), r(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(t);
    r !== -1 && this._listeners.splice(r, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new vt(function(a) {
        t = a;
      }),
      cancel: t
    };
  }
}
const Kr = vt;
function Yr(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function Hr(e) {
  return l.isObject(e) && e.isAxiosError === !0;
}
const it = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(it).forEach(([e, t]) => {
  it[t] = e;
});
const jr = it;
function pn(e) {
  const t = new Fe(e), r = jt(Fe.prototype.request, t);
  return l.extend(r, Fe.prototype, t, { allOwnKeys: !0 }), l.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(a) {
    return pn(Oe(e, a));
  }, r;
}
const X = pn(yt);
X.Axios = Fe;
X.CanceledError = Pe;
X.CancelToken = Kr;
X.isCancel = un;
X.VERSION = fn;
X.toFormData = We;
X.AxiosError = P;
X.Cancel = X.CanceledError;
X.all = function(t) {
  return Promise.all(t);
};
X.spread = Yr;
X.isAxiosError = Hr;
X.mergeConfig = Oe;
X.AxiosHeaders = he;
X.formToJSON = (e) => ln(l.isHTMLForm(e) ? new FormData(e) : e);
X.HttpStatusCode = jr;
X.default = X;
const ae = X, ce = {
  DEVELOPMENT: "development",
  STAGING: "staging",
  SANDBOX: "sandbox",
  PRODUCTION: "production"
}, Z = {
  STRIPE: "stripe",
  AUTHORIZE_NET: "authorize-net",
  NMI: "nmi"
}, Se = {
  [ce.SANDBOX]: "https://jstest.authorize.net/v1/Accept.js",
  [ce.PRODUCTION]: "https://js.authorize.net/v1/Accept.js"
}, we = {
  [ce.SANDBOX]: "https://secure.safewebservices.com/token/Collect.js",
  [ce.PRODUCTION]: "https://secure.safewebservices.com/token/Collect.js"
}, fe = {
  [ce.DEVELOPMENT]: "http://localhost:5055/payments",
  [ce.STAGING]: "https://staging.services.leadconnectorhq.com/payments",
  [ce.PRODUCTION]: "https://services.leadconnectorhq.com/payments"
}, gt = {
  [ce.DEVELOPMENT]: "http://localhost:5075/invoices",
  [ce.STAGING]: "https://staging.services.leadconnectorhq.com/invoices",
  [ce.PRODUCTION]: "https://services.leadconnectorhq.com/invoices"
}, V = {
  ORDER: "order",
  INVOICE: "invoice",
  MANUAL: "manual",
  FORM: "form",
  SURVEY: "survey",
  UPDATE_PAYMENT_METHOD: "update_payment_method"
}, oe = {
  READY: "ready",
  PROCESSING: "processing",
  ERROR: "error",
  SUCCESS: "success"
}, Y = {
  PAYMENT_CALLBACK: "payment-callback"
}, zr = {
  VALIDATION_ERROR: "validation_error"
}, Lt = {
  SERVER_ERROR: "server_error"
}, L = {
  INVALID_PAYMENT_SOURCE: "Invalid source!",
  STRIPE_SDK_LOAD_ERROR: "Could not load Stripe.js",
  STRIPE_PAYMENT_ELEMENT_CREATE_ERROR: "Could not create payment element",
  SOMETHING_WENT_WRONG_IN_INITIATE_PAYMENT: "Something went wrong in initiate payment!",
  SOMETHING_WENT_WRONG_IN_CONFIRMING_PAYMENT: "Something went wrong in confirming payment!",
  FAILED_TO_CONFIRM_PAYMENT: "Failed to confirm payment!",
  PLACE_NEW_ORDER: "Please place a new order!",
  SOMETHING_WENT_WRONG_IN_FETCHING_ORDER: "Something went wrong in fetching order details",
  SOMETHING_WENT_WRONG_IN_FETCHING_PAYMENT_INTEGRATIONS: "Something went wrong in fetching payment integrations",
  PAYMENT_PROVIDER_NOT_FOUND: "No payment provider found",
  INVALID_PAYMENT_PROVIDER: "Invalid payment provider",
  STRIPE_CONNECTION_NOT_FOUND: "No stripe connection details found",
  NMI_CONNECTION_NOT_FOUND: "No NMI connection details found",
  AUTHORIZE_NET_CONNECTION_NOT_FOUND: "No authorize.net connection details found",
  NMI_SDK_LOAD_ERROR: "Something went wrong!! This could be due to an invalid or incomplete field or poor connectivity",
  INVALID_CARD_DETAILS: "Invalid card details",
  SOMETHING_WENT_WRONG: "Something went wrong!",
  CARD_EXPIRY_YEAR_IN_PAST: "Your card's expiration year is in the past.",
  INVALID_CARD_EXPIRY_YEAR: "Your card's expiration year is invalid.",
  CARD_EXPIRY_MONTH_IN_PAST: "Your card's expiration month is in the past",
  SOMETHING_WENT_WRONG_IN_GETTING_CARD_TOKEN: "Something went wrong in getting card token data!",
  SOMETHING_WENT_WRONG_IN_FETCHING_INVOICE: "Something went wrong in fetching invoice details",
  STRIPE_PAYMENT_ELEMENT_LOAD_ERROR: "No valid payment method available. Please contact business owner",
  PINCODE_REQUIRED: "Pincode is required for Billing",
  COUNTRY_REQUIRED: "Country is required for Billing",
  INVALID_PINCODE: "Pincode contains only numbers"
}, mn = (e, t, r, n) => {
  let a = document.getElementById(e);
  return a || (a = document.createElement("script"), a.setAttribute("id", e), a.src = t, r === "nmi" ? a.setAttribute("data-tokenization-key", n) : r === "authorize-net" && a.setAttribute("charset", "utf-8"), document.head.appendChild(a)), a;
}, Wr = (e) => ({
  variant: "inline",
  styleSniffer: !0,
  invalidCss: {
    color: "#B40E3E"
  },
  customCss: {
    "border-color": "rgb(209, 213, 219)",
    "border-style": "solid",
    "border-width": "1px",
    "border-radius": "5px",
    "line-height": "24px",
    padding: "8px 12px",
    "font-size": "12px",
    height: "40px",
    "font-family": "sans-serif"
  },
  focusCss: {
    "border-color": "rgb(1, 125, 233)",
    "border-style": "solid",
    "border-width": "1px"
  },
  fields: {
    ccnumber: {
      title: "Card Number",
      placeholder: "1234 1234 1234 1234",
      selector: `#ccnumber-${e}`
    },
    ccexp: {
      placeholder: "MM / YY",
      selector: `#ccexp-${e}`
    },
    cvv: {
      placeholder: "CVV",
      selector: `#cvv-${e}`
    }
  }
}), Ye = (e) => {
  var r, n;
  let t = (n = (r = e == null ? void 0 : e.response) == null ? void 0 : r.data) == null ? void 0 : n.message;
  return Array.isArray(t) && (t = t.join(", ")), t != null && t.includes("FDS") && (t = "Your transaction has been declined. Please contact the business owner"), t;
}, Jr = [
  {
    name: "Afghanistan",
    code: "AF"
  },
  {
    name: "Aland Islands",
    code: "AX"
  },
  {
    name: "Albania",
    code: "AL"
  },
  {
    name: "Algeria",
    code: "DZ"
  },
  {
    name: "AmericanSamoa",
    code: "AS"
  },
  {
    name: "Andorra",
    code: "AD"
  },
  {
    name: "Angola",
    code: "AO"
  },
  {
    name: "Anguilla",
    code: "AI"
  },
  {
    name: "Antarctica",
    code: "AQ"
  },
  {
    name: "Antigua and Barbuda",
    code: "AG"
  },
  {
    name: "Argentina",
    code: "AR"
  },
  {
    name: "Armenia",
    code: "AM"
  },
  {
    name: "Aruba",
    code: "AW"
  },
  {
    name: "Australia",
    code: "AU"
  },
  {
    name: "Austria",
    code: "AT"
  },
  {
    name: "Azerbaijan",
    code: "AZ"
  },
  {
    name: "Bahamas",
    code: "BS"
  },
  {
    name: "Bahrain",
    code: "BH"
  },
  {
    name: "Bangladesh",
    code: "BD"
  },
  {
    name: "Barbados",
    code: "BB"
  },
  {
    name: "Belarus",
    code: "BY"
  },
  {
    name: "Belgium",
    code: "BE"
  },
  {
    name: "Belize",
    code: "BZ"
  },
  {
    name: "Benin",
    code: "BJ"
  },
  {
    name: "Bermuda",
    code: "BM"
  },
  {
    name: "Bhutan",
    code: "BT"
  },
  {
    name: "Bolivia, Plurinational State of",
    code: "BO"
  },
  {
    name: "Bosnia and Herzegovina",
    code: "BA"
  },
  {
    name: "Botswana",
    code: "BW"
  },
  {
    name: "Brazil",
    code: "BR"
  },
  {
    name: "British Indian Ocean Territory",
    code: "IO"
  },
  {
    name: "Brunei Darussalam",
    code: "BN"
  },
  {
    name: "Bulgaria",
    code: "BG"
  },
  {
    name: "Burkina Faso",
    code: "BF"
  },
  {
    name: "Burundi",
    code: "BI"
  },
  {
    name: "Cambodia",
    code: "KH"
  },
  {
    name: "Cameroon",
    code: "CM"
  },
  {
    name: "Canada",
    code: "CA"
  },
  {
    name: "Cape Verde",
    code: "CV"
  },
  {
    name: "Cayman Islands",
    code: "KY"
  },
  {
    name: "Central African Republic",
    code: "CF"
  },
  {
    name: "Chad",
    code: "TD"
  },
  {
    name: "Chile",
    code: "CL"
  },
  {
    name: "China",
    code: "CN"
  },
  {
    name: "Christmas Island",
    code: "CX"
  },
  {
    name: "Cocos (Keeling) Islands",
    code: "CC"
  },
  {
    name: "Colombia",
    code: "CO"
  },
  {
    name: "Comoros",
    code: "KM"
  },
  {
    name: "Congo",
    code: "CG"
  },
  {
    name: "Congo, The Democratic Republic of the Congo",
    code: "CD"
  },
  {
    name: "Cook Islands",
    code: "CK"
  },
  {
    name: "Costa Rica",
    code: "CR"
  },
  {
    name: "Cote d'Ivoire",
    code: "CI"
  },
  {
    name: "Croatia",
    code: "HR"
  },
  {
    name: "Cuba",
    code: "CU"
  },
  {
    name: "Cyprus",
    code: "CY"
  },
  {
    name: "Czech Republic",
    code: "CZ"
  },
  {
    name: "Denmark",
    code: "DK"
  },
  {
    name: "Djibouti",
    code: "DJ"
  },
  {
    name: "Dominica",
    code: "DM"
  },
  {
    name: "Dominican Republic",
    code: "DO"
  },
  {
    name: "Ecuador",
    code: "EC"
  },
  {
    name: "Egypt",
    code: "EG"
  },
  {
    name: "El Salvador",
    code: "SV"
  },
  {
    name: "Equatorial Guinea",
    code: "GQ"
  },
  {
    name: "Eritrea",
    code: "ER"
  },
  {
    name: "Estonia",
    code: "EE"
  },
  {
    name: "Ethiopia",
    code: "ET"
  },
  {
    name: "Falkland Islands (Malvinas)",
    code: "FK"
  },
  {
    name: "Faroe Islands",
    code: "FO"
  },
  {
    name: "Fiji",
    code: "FJ"
  },
  {
    name: "Finland",
    code: "FI"
  },
  {
    name: "France",
    code: "FR"
  },
  {
    name: "French Guiana",
    code: "GF"
  },
  {
    name: "French Polynesia",
    code: "PF"
  },
  {
    name: "Gabon",
    code: "GA"
  },
  {
    name: "Gambia",
    code: "GM"
  },
  {
    name: "Georgia",
    code: "GE"
  },
  {
    name: "Germany",
    code: "DE"
  },
  {
    name: "Ghana",
    code: "GH"
  },
  {
    name: "Gibraltar",
    code: "GI"
  },
  {
    name: "Greece",
    code: "GR"
  },
  {
    name: "Greenland",
    code: "GL"
  },
  {
    name: "Grenada",
    code: "GD"
  },
  {
    name: "Guadeloupe",
    code: "GP"
  },
  {
    name: "Guam",
    code: "GU"
  },
  {
    name: "Guatemala",
    code: "GT"
  },
  {
    name: "Guernsey",
    code: "GG"
  },
  {
    name: "Guinea",
    code: "GN"
  },
  {
    name: "Guinea-Bissau",
    code: "GW"
  },
  {
    name: "Guyana",
    code: "GY"
  },
  {
    name: "Haiti",
    code: "HT"
  },
  {
    name: "Holy See (Vatican City State)",
    code: "VA"
  },
  {
    name: "Honduras",
    code: "HN"
  },
  {
    name: "Hong Kong",
    code: "HK"
  },
  {
    name: "Hungary",
    code: "HU"
  },
  {
    name: "Iceland",
    code: "IS"
  },
  {
    name: "India",
    code: "IN"
  },
  {
    name: "Indonesia",
    code: "ID"
  },
  {
    name: "Iran, Islamic Republic of Persian Gulf",
    code: "IR"
  },
  {
    name: "Iraq",
    code: "IQ"
  },
  {
    name: "Ireland",
    code: "IE"
  },
  {
    name: "Isle of Man",
    code: "IM"
  },
  {
    name: "Israel",
    code: "IL"
  },
  {
    name: "Italy",
    code: "IT"
  },
  {
    name: "Jamaica",
    code: "JM"
  },
  {
    name: "Japan",
    code: "JP"
  },
  {
    name: "Jersey",
    code: "JE"
  },
  {
    name: "Jordan",
    code: "JO"
  },
  {
    name: "Kazakhstan",
    code: "KZ"
  },
  {
    name: "Kenya",
    code: "KE"
  },
  {
    name: "Kiribati",
    code: "KI"
  },
  {
    name: "Korea, Democratic People's Republic of Korea",
    code: "KP"
  },
  {
    name: "Korea, Republic of South Korea",
    code: "KR"
  },
  {
    name: "Kuwait",
    code: "KW"
  },
  {
    name: "Kyrgyzstan",
    code: "KG"
  },
  {
    name: "Laos",
    code: "LA"
  },
  {
    name: "Latvia",
    code: "LV"
  },
  {
    name: "Lebanon",
    code: "LB"
  },
  {
    name: "Lesotho",
    code: "LS"
  },
  {
    name: "Liberia",
    code: "LR"
  },
  {
    name: "Libyan Arab Jamahiriya",
    code: "LY"
  },
  {
    name: "Liechtenstein",
    code: "LI"
  },
  {
    name: "Lithuania",
    code: "LT"
  },
  {
    name: "Luxembourg",
    code: "LU"
  },
  {
    name: "Macao",
    code: "MO"
  },
  {
    name: "Macedonia",
    code: "MK"
  },
  {
    name: "Madagascar",
    code: "MG"
  },
  {
    name: "Malawi",
    code: "MW"
  },
  {
    name: "Malaysia",
    code: "MY"
  },
  {
    name: "Maldives",
    code: "MV"
  },
  {
    name: "Mali",
    code: "ML"
  },
  {
    name: "Malta",
    code: "MT"
  },
  {
    name: "Marshall Islands",
    code: "MH"
  },
  {
    name: "Martinique",
    code: "MQ"
  },
  {
    name: "Mauritania",
    code: "MR"
  },
  {
    name: "Mauritius",
    code: "MU"
  },
  {
    name: "Mayotte",
    code: "YT"
  },
  {
    name: "Mexico",
    code: "MX"
  },
  {
    name: "Micronesia, Federated States of Micronesia",
    code: "FM"
  },
  {
    name: "Moldova",
    code: "MD"
  },
  {
    name: "Monaco",
    code: "MC"
  },
  {
    name: "Mongolia",
    code: "MN"
  },
  {
    name: "Montenegro",
    code: "ME"
  },
  {
    name: "Montserrat",
    code: "MS"
  },
  {
    name: "Morocco",
    code: "MA"
  },
  {
    name: "Mozambique",
    code: "MZ"
  },
  {
    name: "Myanmar",
    code: "MM"
  },
  {
    name: "Namibia",
    code: "NA"
  },
  {
    name: "Nauru",
    code: "NR"
  },
  {
    name: "Nepal",
    code: "NP"
  },
  {
    name: "Netherlands",
    code: "NL"
  },
  {
    name: "Netherlands Antilles",
    code: "AN"
  },
  {
    name: "New Caledonia",
    code: "NC"
  },
  {
    name: "New Zealand",
    code: "NZ"
  },
  {
    name: "Nicaragua",
    code: "NI"
  },
  {
    name: "Niger",
    code: "NE"
  },
  {
    name: "Nigeria",
    code: "NG"
  },
  {
    name: "Niue",
    code: "NU"
  },
  {
    name: "Norfolk Island",
    code: "NF"
  },
  {
    name: "Northern Mariana Islands",
    code: "MP"
  },
  {
    name: "Norway",
    code: "NO"
  },
  {
    name: "Oman",
    code: "OM"
  },
  {
    name: "Pakistan",
    code: "PK"
  },
  {
    name: "Palau",
    code: "PW"
  },
  {
    name: "Palestinian Territory, Occupied",
    code: "PS"
  },
  {
    name: "Panama",
    code: "PA"
  },
  {
    name: "Papua New Guinea",
    code: "PG"
  },
  {
    name: "Paraguay",
    code: "PY"
  },
  {
    name: "Peru",
    code: "PE"
  },
  {
    name: "Philippines",
    code: "PH"
  },
  {
    name: "Pitcairn",
    code: "PN"
  },
  {
    name: "Poland",
    code: "PL"
  },
  {
    name: "Portugal",
    code: "PT"
  },
  {
    name: "Puerto Rico",
    code: "PR"
  },
  {
    name: "Qatar",
    code: "QA"
  },
  {
    name: "Romania",
    code: "RO"
  },
  {
    name: "Russia",
    code: "RU"
  },
  {
    name: "Rwanda",
    code: "RW"
  },
  {
    name: "Reunion",
    code: "RE"
  },
  {
    name: "Saint Barthelemy",
    code: "BL"
  },
  {
    name: "Saint Helena, Ascension and Tristan Da Cunha",
    code: "SH"
  },
  {
    name: "Saint Kitts and Nevis",
    code: "KN"
  },
  {
    name: "Saint Lucia",
    code: "LC"
  },
  {
    name: "Saint Martin",
    code: "MF"
  },
  {
    name: "Saint Pierre and Miquelon",
    code: "PM"
  },
  {
    name: "Saint Vincent and the Grenadines",
    code: "VC"
  },
  {
    name: "Samoa",
    code: "WS"
  },
  {
    name: "San Marino",
    code: "SM"
  },
  {
    name: "Sao Tome and Principe",
    code: "ST"
  },
  {
    name: "Saudi Arabia",
    code: "SA"
  },
  {
    name: "Senegal",
    code: "SN"
  },
  {
    name: "Serbia",
    code: "RS"
  },
  {
    name: "Seychelles",
    code: "SC"
  },
  {
    name: "Sierra Leone",
    code: "SL"
  },
  {
    name: "Singapore",
    code: "SG"
  },
  {
    name: "Slovakia",
    code: "SK"
  },
  {
    name: "Slovenia",
    code: "SI"
  },
  {
    name: "Solomon Islands",
    code: "SB"
  },
  {
    name: "Somalia",
    code: "SO"
  },
  {
    name: "South Africa",
    code: "ZA"
  },
  {
    name: "South Sudan",
    code: "SS"
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    code: "GS"
  },
  {
    name: "Spain",
    code: "ES"
  },
  {
    name: "Sri Lanka",
    code: "LK"
  },
  {
    name: "Sudan",
    code: "SD"
  },
  {
    name: "Suriname",
    code: "SR"
  },
  {
    name: "Svalbard and Jan Mayen",
    code: "SJ"
  },
  {
    name: "Swaziland",
    code: "SZ"
  },
  {
    name: "Sweden",
    code: "SE"
  },
  {
    name: "Switzerland",
    code: "CH"
  },
  {
    name: "Syrian Arab Republic",
    code: "SY"
  },
  {
    name: "Taiwan",
    code: "TW"
  },
  {
    name: "Tajikistan",
    code: "TJ"
  },
  {
    name: "Tanzania, United Republic of Tanzania",
    code: "TZ"
  },
  {
    name: "Thailand",
    code: "TH"
  },
  {
    name: "Timor-Leste",
    code: "TL"
  },
  {
    name: "Togo",
    code: "TG"
  },
  {
    name: "Tokelau",
    code: "TK"
  },
  {
    name: "Tonga",
    code: "TO"
  },
  {
    name: "Trinidad and Tobago",
    code: "TT"
  },
  {
    name: "Tunisia",
    code: "TN"
  },
  {
    name: "Turkey",
    code: "TR"
  },
  {
    name: "Turkmenistan",
    code: "TM"
  },
  {
    name: "Turks and Caicos Islands",
    code: "TC"
  },
  {
    name: "Tuvalu",
    code: "TV"
  },
  {
    name: "Uganda",
    code: "UG"
  },
  {
    name: "Ukraine",
    code: "UA"
  },
  {
    name: "United Arab Emirates",
    code: "AE"
  },
  {
    name: "United Kingdom",
    code: "GB"
  },
  {
    name: "United States",
    code: "US"
  },
  {
    name: "Uruguay",
    code: "UY"
  },
  {
    name: "Uzbekistan",
    code: "UZ"
  },
  {
    name: "Vanuatu",
    code: "VU"
  },
  {
    name: "Venezuela, Bolivarian Republic of Venezuela",
    code: "VE"
  },
  {
    name: "Vietnam",
    code: "VN"
  },
  {
    name: "Virgin Islands, British",
    code: "VG"
  },
  {
    name: "Virgin Islands, U.S.",
    code: "VI"
  },
  {
    name: "Wallis and Futuna",
    code: "WF"
  },
  {
    name: "Yemen",
    code: "YE"
  },
  {
    name: "Zambia",
    code: "ZM"
  },
  {
    name: "Zimbabwe",
    code: "ZW"
  }
];
var Ut;
const hn = typeof window < "u";
hn && ((Ut = window == null ? void 0 : window.navigator) != null && Ut.userAgent) && /iP(ad|hone|od)/.test(window.navigator.userAgent);
function Zr(e) {
  return typeof e == "function" ? e() : Ht(e);
}
function Xr(e) {
  return e;
}
function Qr(e) {
  return Cn() ? (On(e), !0) : !1;
}
function ea(e, t = !0) {
  bn() ? be(e) : t ? e() : Rn(e);
}
function qe(e) {
  var t;
  const r = Zr(e);
  return (t = r == null ? void 0 : r.$el) != null ? t : r;
}
const yn = hn ? window : void 0;
function ta(e, t = !1) {
  const r = _(), n = () => r.value = !!e();
  return n(), ea(n, t), r;
}
const Ft = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, qt = "__vueuse_ssr_handlers__";
Ft[qt] = Ft[qt] || {};
var $t = Object.getOwnPropertySymbols, na = Object.prototype.hasOwnProperty, ra = Object.prototype.propertyIsEnumerable, aa = (e, t) => {
  var r = {};
  for (var n in e)
    na.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && $t)
    for (var n of $t(e))
      t.indexOf(n) < 0 && ra.call(e, n) && (r[n] = e[n]);
  return r;
};
function oa(e, t, r = {}) {
  const n = r, { window: a = yn } = n, o = aa(n, ["window"]);
  let i;
  const c = ta(() => a && "ResizeObserver" in a), u = () => {
    i && (i.disconnect(), i = void 0);
  }, s = He(() => qe(e), (d) => {
    u(), c.value && a && d && (i = new ResizeObserver(t), i.observe(d, o));
  }, { immediate: !0, flush: "post" }), f = () => {
    u(), s();
  };
  return Qr(f), {
    isSupported: c,
    stop: f
  };
}
function ia(e, t = { width: 0, height: 0 }, r = {}) {
  const { window: n = yn, box: a = "content-box" } = r, o = _n(() => {
    var u, s;
    return (s = (u = qe(e)) == null ? void 0 : u.namespaceURI) == null ? void 0 : s.includes("svg");
  }), i = _(t.width), c = _(t.height);
  return oa(e, ([u]) => {
    const s = a === "border-box" ? u.borderBoxSize : a === "content-box" ? u.contentBoxSize : u.devicePixelContentBoxSize;
    if (n && o.value) {
      const f = qe(e);
      if (f) {
        const d = n.getComputedStyle(f);
        i.value = parseFloat(d.width), c.value = parseFloat(d.height);
      }
    } else if (s) {
      const f = Array.isArray(s) ? s : [s];
      i.value = f.reduce((d, { inlineSize: O }) => d + O, 0), c.value = f.reduce((d, { blockSize: O }) => d + O, 0);
    } else
      i.value = u.contentRect.width, c.value = u.contentRect.height;
  }, r), He(() => qe(e), (u) => {
    i.value = u ? t.width : 0, c.value = u ? t.height : 0;
  }), {
    width: i,
    height: c
  };
}
var Gt;
(function(e) {
  e.UP = "UP", e.RIGHT = "RIGHT", e.DOWN = "DOWN", e.LEFT = "LEFT", e.NONE = "NONE";
})(Gt || (Gt = {}));
var sa = Object.defineProperty, Vt = Object.getOwnPropertySymbols, ca = Object.prototype.hasOwnProperty, la = Object.prototype.propertyIsEnumerable, kt = (e, t, r) => t in e ? sa(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, ua = (e, t) => {
  for (var r in t || (t = {}))
    ca.call(t, r) && kt(e, r, t[r]);
  if (Vt)
    for (var r of Vt(t))
      la.call(t, r) && kt(e, r, t[r]);
  return e;
};
const da = {
  easeInSine: [0.12, 0, 0.39, 0],
  easeOutSine: [0.61, 1, 0.88, 1],
  easeInOutSine: [0.37, 0, 0.63, 1],
  easeInQuad: [0.11, 0, 0.5, 0],
  easeOutQuad: [0.5, 1, 0.89, 1],
  easeInOutQuad: [0.45, 0, 0.55, 1],
  easeInCubic: [0.32, 0, 0.67, 0],
  easeOutCubic: [0.33, 1, 0.68, 1],
  easeInOutCubic: [0.65, 0, 0.35, 1],
  easeInQuart: [0.5, 0, 0.75, 0],
  easeOutQuart: [0.25, 1, 0.5, 1],
  easeInOutQuart: [0.76, 0, 0.24, 1],
  easeInQuint: [0.64, 0, 0.78, 0],
  easeOutQuint: [0.22, 1, 0.36, 1],
  easeInOutQuint: [0.83, 0, 0.17, 1],
  easeInExpo: [0.7, 0, 0.84, 0],
  easeOutExpo: [0.16, 1, 0.3, 1],
  easeInOutExpo: [0.87, 0, 0.13, 1],
  easeInCirc: [0.55, 0, 1, 0.45],
  easeOutCirc: [0, 0.55, 0.45, 1],
  easeInOutCirc: [0.85, 0, 0.15, 1],
  easeInBack: [0.36, 0, 0.66, -0.56],
  easeOutBack: [0.34, 1.56, 0.64, 1],
  easeInOutBack: [0.68, -0.6, 0.32, 1.6]
};
ua({
  linear: Xr
}, da);
const Nt = /* @__PURE__ */ Ie({
  __name: "CreditCardContainer",
  setup(e) {
    const t = _(null), r = _("credit-card-container"), { width: n } = ia(
      t
    );
    return He(n, () => {
      n.value < 470 ? r.value = "credit-card-container" : r.value = "inline-credit-card-container";
    }), (a, o) => (K(), ue("div", {
      ref_key: "creditCardContainerEl",
      ref: t,
      class: Ce(r.value)
    }, [
      An(a.$slots, "default")
    ], 2));
  }
}), En = (e) => (ut("data-v-2d0ac45b"), e = e(), dt(), e), fa = /* @__PURE__ */ En(() => /* @__PURE__ */ q("label", {
  for: "pincode",
  class: "card-input-label"
}, "ZIP", -1)), pa = ["value"], ma = /* @__PURE__ */ En(() => /* @__PURE__ */ q("label", {
  for: "countryCode",
  class: "card-input-label"
}, "Country", -1)), ha = ["value"], ya = ["value"], Ea = {
  name: "UIBillingElement",
  inheritAttrs: !1
}, va = /* @__PURE__ */ Ie({
  ...Ea,
  props: {
    enableBillingInfo: {
      type: Boolean,
      required: !0
    },
    pincode: {
      type: String,
      required: !1
    },
    countryCode: {
      type: String,
      required: !1
    }
  },
  emits: ["update:pincode", "update:countryCode"],
  setup(e, { expose: t, emit: r }) {
    const n = e;
    t({ validateBillingDetails: s });
    const a = _(!0), o = _(), i = _(), c = Jr, u = 20;
    be(() => {
      a.value = !1;
    });
    function s() {
      return n.pincode ? n.countryCode ? !0 : L.COUNTRY_REQUIRED : L.PINCODE_REQUIRED;
    }
    function f(O) {
      r("update:pincode", O.target.value), s();
    }
    function d(O) {
      r("update:countryCode", O.target.value), s();
    }
    return (O, b) => (K(), Ne(Nt, null, {
      default: lt(() => [
        q("div", null, [
          fa,
          q("input", {
            type: "text",
            name: "pincode",
            value: e.pincode,
            id: "pincode",
            maxlength: u,
            placeholder: "123456",
            class: Ce(["card-input", o.value ? "card-input-error" : ""]),
            onChange: f,
            onFocusout: f
          }, null, 42, pa)
        ]),
        q("div", null, [
          ma,
          q("select", {
            name: "countryCode",
            value: e.countryCode,
            id: "countryCode",
            class: Ce(["card-input", i.value ? "card-input-error" : ""]),
            onChange: d,
            onFocusout: d
          }, [
            (K(!0), ue(je, null, Tn(Ht(c), (m) => (K(), ue("option", {
              key: m.code,
              value: m.code
            }, Mn(m.name), 9, ya))), 128))
          ], 42, ha)
        ])
      ]),
      _: 1
    }));
  }
});
const It = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [n, a] of t)
    r[n] = a;
  return r;
}, vn = /* @__PURE__ */ It(va, [["__scopeId", "data-v-2d0ac45b"]]), ga = (e) => (ut("data-v-2ac2b44d"), e = e(), dt(), e), Na = {
  key: 0,
  class: "payment-mode-container"
}, Ia = /* @__PURE__ */ ga(() => /* @__PURE__ */ q("span", { class: "test-mode-badge" }, "Test Mode", -1)), Sa = [
  Ia
], wa = /* @__PURE__ */ Ie({
  __name: "TestModeBadge",
  props: {
    liveMode: { type: Boolean }
  },
  setup(e) {
    return (t, r) => e.liveMode === !1 ? (K(), ue("div", Na, Sa)) : de("", !0);
  }
});
const St = /* @__PURE__ */ It(wa, [["__scopeId", "data-v-2ac2b44d"]]), wt = (e) => (ut("data-v-5a183429"), e = e(), dt(), e), Ca = /* @__PURE__ */ wt(() => /* @__PURE__ */ q("label", {
  for: "cardNumber",
  class: "card-input-label"
}, "Card Number", -1)), Oa = ["value", "disabled", "id", "maxlength"], ba = { class: "credit-card-sub-container" }, Ra = /* @__PURE__ */ wt(() => /* @__PURE__ */ q("label", {
  for: "cardExpiration",
  class: "card-input-label"
}, "Expiration", -1)), _a = ["value", "disabled", "id"], Aa = /* @__PURE__ */ wt(() => /* @__PURE__ */ q("label", {
  for: "cardExpiration",
  class: "card-input-label"
}, "CVC", -1)), Ta = ["value", "disabled", "id", "maxlength"], Ma = { key: 1 }, Ba = {
  name: "UIAuthorizeNetCardElement",
  inheritAttrs: !1
}, Pa = /* @__PURE__ */ Ie({
  ...Ba,
  props: {
    env: {
      type: String,
      required: !0
    },
    id: {
      type: String,
      required: !0
    },
    altId: {
      type: String,
      required: !0
    },
    altType: {
      type: String,
      required: !0
    },
    liveMode: {
      type: Boolean,
      required: !0
    },
    showModeBadge: {
      type: Boolean,
      required: !1,
      default: !0
    },
    debug: {
      type: Boolean,
      required: !1,
      default: !1
    },
    traceId: {
      type: String,
      required: !1
    },
    merchantPublicClientKey: {
      type: String,
      required: !0
    },
    merchantLoginId: {
      type: String,
      required: !0
    },
    showBillingFields: {
      type: Boolean,
      required: !0
    }
  },
  emits: [Y.PAYMENT_CALLBACK],
  setup(e, { expose: t, emit: r }) {
    const n = e, a = _(!0), o = _(!1), i = _(!1), c = _(!1), u = _(!1), s = _(!1), f = _(!1), d = _(), O = _(!1), b = _(), m = _(!1), I = _(), H = _(!1), N = _(), R = _(null), x = _(""), k = _("US"), $ = (g) => O.value = g, S = (g) => m.value = g, h = (g) => H.value = g, C = (g) => {
      r(Y.PAYMENT_CALLBACK, {
        type: oe.ERROR,
        message: g,
        provider: Z.AUTHORIZE_NET
      });
    }, G = () => {
      $(!1), S(!1), h(!1), C("");
    };
    be(() => p());
    async function p() {
      const { liveMode: g } = n, y = g ? Se == null ? void 0 : Se[ce.PRODUCTION] : Se == null ? void 0 : Se[ce.SANDBOX];
      a.value = !0, await mn(
        "accept-js",
        y,
        Z.AUTHORIZE_NET
      ), r(Y.PAYMENT_CALLBACK, {
        type: oe.READY,
        value: !0,
        provider: Z.AUTHORIZE_NET
      }), a.value = !1;
    }
    const E = (g) => {
      var y;
      v((y = g == null ? void 0 : g.target) == null ? void 0 : y.value);
    }, v = (g) => {
      $(!1);
      const y = g.replace(/\D/g, "");
      return o.value = !1, i.value = !1, f.value = !1, c.value = !1, u.value = !1, s.value = !1, /^3[47]\d{0,13}$/.test(y) ? (o.value = !0, N.value = 17, d.value = y.replace(/(\d{4})/, "$1 ").replace(/(\d{4}) (\d{6})/, "$1 $2 ")) : /^3(?:0[0-5]|[68]\d)\d{0,11}$/.test(y) ? (i.value = !0, N.value = 16, d.value = y.replace(/(\d{4})/, "$1 ").replace(/(\d{4}) (\d{6})/, "$1 $2 ")) : /^4[0]\d{0,11}$/.test(y) ? (c.value = !0, N.value = 19, d.value = y.replace(/(\d{4})/, "$1 ").replace(/(\d{4}) (\d{5})/, "$1 $2 ")) : /^5[12345]\d{0,13}$/.test(y) ? (f.value = !0, N.value = 19, d.value = g.replace(/\W/gi, "").replace(/(.{4})/g, "$1 ")) : /^5\d{0,14}$/.test(y) ? (u.value = !0, N.value = 17, d.value = y.replace(/(\d{4})/, "$1 ").replace(/(\d{4}) (\d{6})/, "$1 $2 ")) : /^6011\d{0,12}$/.test(y) || /^5\d{0,14}$/.test(y) ? (u.value = !0, N.value = 18, d.value = y.replace(/(\d{4})/, "$1 ").replace(/(\d{4}) (\d{6})/, "$1 $2 ")) : /^2131|1800\d{11}$/.test(y) ? (s.value = !0, N.value = 17, d.value = y.replace(/(\d{4})/, "$1 ").replace(/(\d{4}) (\d{6})/, "$1 $2 ")) : (N.value = 19, f.value = !0, d.value = g.replace(/\W/gi, "").replace(/(.{4})/g, "$1 ")), d.value = d.value.replace(/\s*$/, ""), isNaN(Number(d.value.replace(/\s/g, ""))) && $(!0), d.value;
    }, B = (g) => {
      var y, w, F, ee, U;
      if (d.value = g.target.value, !d.value) {
        $(!0);
        return;
      }
      if (isNaN(Number(d.value.replace(/\s/g, ""))))
        return $(!0);
      c.value && d.value.length < 15 || (o.value || u.value) && ((y = d.value) == null ? void 0 : y.length) < 17 || i.value && ((w = d.value) == null ? void 0 : w.length) < 16 || f.value && ((F = d.value) == null ? void 0 : F.length) < 19 ? $(!0) : $(!1), o.value && ((ee = I.value) == null ? void 0 : ee.length) < 4 || !o.value && ((U = I.value) == null ? void 0 : U.length) < 3 ? h(!0) : h(!1);
    }, M = (g) => {
      const y = g.which || g.keyCode;
      if (y !== 8 && y !== 9 && y !== 91 && y !== 65 && y !== 86 && y !== 37 && y !== 38 && y !== 39 && y !== 40 && isNaN(Number(g.key))) {
        g.preventDefault();
        return;
      }
      return !0;
    }, A = (g) => {
      g.target.value.length > 5 || (S(!1), b.value = g.target.value.replace(
        /^([1-9]\/|[2-9])$/g,
        "0$1 /"
        // 3 > 03/
      ).replace(
        /^(0[1-9]|1[0-2])$/g,
        "$1/"
        // 11 > 11/
      ).replace(
        /^([0-1])([3-9])$/g,
        "0$1/$2"
        // 13 > 01/3
      ).replace(
        /^(0?[1-9]|1[0-2])([0-9]{2})$/g,
        "$1/$2"
        // 141 > 01/41
      ).replace(
        /^([0]+)\/|[0]+$/g,
        "0"
        // 0/ > 0 and 00 > 0
      ).replace(
        /[^\d\/]|^[\/]*$/g,
        //eslint-disable-line
        ""
        // To allow only digits and `/`
      ).replace(
        /\/\//g,
        "/"
        // Prevent entering more than 1 `/`
      ));
    }, T = (g) => {
      var te;
      if (b.value = g.target.value, C(""), !((te = g == null ? void 0 : g.target) != null && te.value)) {
        C(""), S(!0);
        return;
      }
      const y = g.target.value.split("/"), w = Number(y[0]), F = Number(y[1]), ee = (/* @__PURE__ */ new Date()).getMonth() + 1, U = (/* @__PURE__ */ new Date()).getFullYear() % 100;
      !w || !F ? (C(""), S(!0)) : F < U ? (S(!0), C(L.CARD_EXPIRY_YEAR_IN_PAST)) : F > U + 50 ? (S(!0), C(L.INVALID_CARD_EXPIRY_YEAR)) : w < ee && F == U ? (S(!0), C(L.CARD_EXPIRY_MONTH_IN_PAST)) : (C(""), S(!1));
    }, D = (g) => {
      var y;
      I.value = (y = g == null ? void 0 : g.target) == null ? void 0 : y.value, o.value && I.value.length < 4 || !o.value && I.value.length < 3 ? h(!0) : h(!1);
    };
    function Q() {
      if (!z())
        return !1;
      if (n.showBillingFields) {
        const y = R.value.validateBillingDetails();
        return y === !0 ? !0 : (C(y), !1);
      }
      return G(), !0;
    }
    async function j(g) {
      var y, w, F, ee;
      try {
        r(Y.PAYMENT_CALLBACK, {
          type: oe.PROCESSING,
          value: !0,
          provider: Z.AUTHORIZE_NET
        });
        const U = await W(), te = I.value, { opaqueData: re } = U || {}, { source: J } = g;
        if (J === V.UPDATE_PAYMENT_METHOD) {
          const se = await ie(re, te, g);
          return r(Y.PAYMENT_CALLBACK, {
            type: oe.SUCCESS,
            data: se,
            provider: Z.AUTHORIZE_NET
          }), !0;
        }
        const le = await Ee(
          re,
          te,
          g
        );
        return r(Y.PAYMENT_CALLBACK, {
          type: oe.SUCCESS,
          data: le,
          provider: Z.AUTHORIZE_NET
        }), !0;
      } catch (U) {
        if (U.type === Lt.SERVER_ERROR)
          C((ee = (F = (w = (y = U == null ? void 0 : U.response) == null ? void 0 : y.messages) == null ? void 0 : w.message) == null ? void 0 : F[0]) == null ? void 0 : ee.text);
        else {
          const te = Ye(U);
          C(te || (U == null ? void 0 : U.message) || L.SOMETHING_WENT_WRONG);
        }
        return !1;
      }
    }
    function z() {
      return d.value || $(!0), b.value || S(!0), I.value || h(!0), !(O.value || m.value || H.value);
    }
    function W() {
      var F, ee, U;
      const { merchantPublicClientKey: g, merchantLoginId: y } = n, w = {
        authData: {
          clientKey: g,
          apiLoginID: y
        },
        cardData: {
          cardNumber: (F = d.value) == null ? void 0 : F.replaceAll(/\s/g, ""),
          month: (ee = b.value) == null ? void 0 : ee.split("/")[0],
          year: (U = b.value) == null ? void 0 : U.split("/")[1],
          cardCode: I.value
        }
      };
      return new Promise(function(te, re) {
        window == null || window.Accept.dispatchData(w, function(J) {
          var le, se, ne;
          return ((se = (le = J == null ? void 0 : J.messages) == null ? void 0 : le.resultCode) == null ? void 0 : se.toUpperCase()) === "OK" ? (ne = J == null ? void 0 : J.opaqueData) != null && ne.dataValue ? te(J) : re({
            message: L.SOMETHING_WENT_WRONG_IN_GETTING_CARD_TOKEN
          }) : re({ type: Lt.SERVER_ERROR, response: J });
        });
      });
    }
    async function ie(g, y, w) {
      const { env: F, altId: ee, altType: U } = n, { contactId: te, token: re, liveMode: J } = w, le = `${fe[F]}/authorize-net/recurring/payment-method`, se = {
        altId: ee,
        opaqueData: g,
        cardCode: y,
        contactId: te,
        token: re,
        liveMode: J
      }, { data: ne } = await ae.put(le, se, {});
      if (!ne.success)
        throw new Error(ne.message);
      return ne;
    }
    async function Ee(g, y, w) {
      const { source: F } = w;
      if (F === V.ORDER)
        return await _e(g, y, w);
      if (F === V.INVOICE)
        return await Sn(g, y, w);
      if ([
        V.MANUAL,
        V.FORM,
        V.SURVEY
      ].includes(F))
        return await wn(g, y, w);
      throw new Error(L.INVALID_PAYMENT_SOURCE);
    }
    async function _e(g, y, w) {
      const { env: F, altId: ee, altType: U } = n, { sourceId: te } = w, re = (w == null ? void 0 : w.traceId) || n.traceId, J = `${fe[F]}/authorize-net/order/pay`, le = {
        ...w == null ? void 0 : w.extra,
        altId: ee,
        altType: U,
        orderId: te,
        opaqueData: g,
        cardCode: y
      };
      if (n.showBillingFields) {
        const Ae = {
          pincode: x.value,
          countryCode: k.value
        };
        le.billingInfo = Ae;
      }
      const se = {};
      re && (se["x-parent-trace-context"] = re);
      const { data: ne } = await ae.post(J, le, { headers: se });
      if (!ne.success)
        throw new Error(ne.message);
      return ne;
    }
    async function Sn(g, y, w) {
      const { env: F, altId: ee, altType: U } = n, { sourceId: te } = w, re = (w == null ? void 0 : w.traceId) || n.traceId, J = `${gt[F]}/authorize-net/payment`, le = {
        ...w == null ? void 0 : w.extra,
        altId: ee,
        altType: U,
        invoiceId: te,
        opaqueData: g,
        cardCode: y
      }, se = {};
      re && (se["x-parent-trace-context"] = re);
      const { data: ne } = await ae.post(J, le, { headers: se });
      if (!ne.success)
        throw new Error(ne.message);
      return ne;
    }
    async function wn(g, y, w) {
      const { env: F, altId: ee, altType: U } = n, { source: te, sourceId: re } = w, J = (w == null ? void 0 : w.traceId) || n.traceId, le = `${fe[F]}/authorize-net/pay-public`, se = {
        ...w == null ? void 0 : w.extra,
        altId: ee,
        altType: U,
        liveMode: n.liveMode,
        source: te,
        sourceId: re,
        opaqueData: g,
        cardCode: y
      }, ne = {};
      J && (ne["x-parent-trace-context"] = J);
      const { data: Ae } = await ae.post(le, se, { headers: ne });
      if (!Ae.success)
        throw new Error(Ae.message);
      return Ae;
    }
    return t({
      validatePayment: Q,
      confirmPayment: j
    }), (g, y) => (K(), ue(je, null, [
      e.showModeBadge && !a.value ? (K(), Ne(St, {
        key: 0,
        liveMode: e.liveMode
      }, null, 8, ["liveMode"])) : de("", !0),
      ke(Nt, null, {
        default: lt(() => [
          q("div", null, [
            Ca,
            q("input", {
              type: "text",
              name: "cc",
              value: d.value,
              disabled: a.value,
              id: `cc-${e.id}`,
              maxlength: N.value,
              placeholder: "1234 1234 1234 1234",
              class: Ce(["card-input", O.value ? "card-input-error" : ""]),
              onKeyup: E,
              onKeydown: M,
              onChange: B,
              onFocusout: B
            }, null, 42, Oa)
          ]),
          q("div", ba, [
            q("div", null, [
              Ra,
              q("input", {
                type: "text",
                name: "card-expiration",
                value: b.value,
                disabled: a.value,
                id: `card-expiration-${e.id}`,
                maxlength: "5",
                placeholder: "MM / YY",
                class: Ce([
                  "card-input",
                  m.value ? "card-input-error" : ""
                ]),
                onKeydown: M,
                onChange: T,
                onKeyup: A,
                onFocusout: T
              }, null, 42, _a)
            ]),
            q("div", null, [
              Aa,
              q("input", {
                type: "text",
                name: "card-cvc",
                value: I.value,
                disabled: a.value,
                id: `card-cvc-${e.id}`,
                maxlength: o.value ? "4" : "3",
                placeholder: "CVC",
                class: Ce(["card-input", H.value ? "card-input-error" : ""]),
                onChange: D,
                onKeydown: M,
                onFocusout: D
              }, null, 42, Ta)
            ])
          ])
        ]),
        _: 1
      }),
      !a.value && e.showBillingFields ? (K(), ue("div", Ma, [
        ke(vn, {
          enableBillingInfo: e.showBillingFields,
          pincode: x.value,
          "onUpdate:pincode": y[0] || (y[0] = (w) => x.value = w),
          countryCode: k.value,
          "onUpdate:countryCode": y[1] || (y[1] = (w) => k.value = w),
          ref_key: "UIBillingElementRef",
          ref: R
        }, null, 8, ["enableBillingInfo", "pincode", "countryCode"])
      ])) : de("", !0)
    ], 64));
  }
});
const xa = /* @__PURE__ */ It(Pa, [["__scopeId", "data-v-5a183429"]]), Da = {
  key: 0,
  for: "cardNumber",
  class: "card-input-label"
}, La = ["id"], Ua = { class: "credit-card-sub-container" }, Fa = {
  key: 0,
  for: "cardExpiration",
  class: "card-input-label"
}, qa = ["id"], $a = {
  key: 0,
  for: "cardExpiration",
  class: "card-input-label"
}, Ga = ["id"], Va = { key: 1 }, ka = {
  name: "UINMICardElement",
  inheritAttrs: !1
}, Ka = /* @__PURE__ */ Ie({
  ...ka,
  props: {
    env: {
      type: String,
      required: !0
    },
    id: {
      type: String,
      required: !0
    },
    altId: {
      type: String,
      required: !0
    },
    altType: {
      type: String,
      required: !0
    },
    liveMode: {
      type: Boolean,
      required: !0
    },
    showModeBadge: {
      type: Boolean,
      required: !1,
      default: !0
    },
    debug: {
      type: Boolean,
      required: !1,
      default: !1
    },
    traceId: {
      type: String,
      required: !1
    },
    merchantPublicKey: {
      type: String,
      required: !0
    },
    showBillingFields: {
      type: Boolean,
      required: !0
    }
  },
  emits: [Y.PAYMENT_CALLBACK],
  setup(e, { expose: t, emit: r }) {
    const n = e, a = _(!0), o = _(!1), i = _(), c = _({}), u = _(""), s = _("US"), f = _(null), d = (S) => {
      r(Y.PAYMENT_CALLBACK, {
        type: oe.ERROR,
        message: S,
        provider: Z.NMI
      });
    };
    be(() => O());
    async function O() {
      const { id: S, liveMode: h, merchantPublicKey: C } = n;
      if (window != null && window.CollectJS)
        await b(S);
      else {
        const G = h ? we == null ? void 0 : we[ce.PRODUCTION] : we == null ? void 0 : we[ce.SANDBOX];
        a.value = !0;
        const p = await mn(
          "collect-js",
          G,
          Z.NMI,
          C
        );
        p.onload = async () => {
          await b(S);
        };
      }
    }
    const b = async (S) => {
      var C;
      const h = Wr(S);
      await ((C = window == null ? void 0 : window.CollectJS) == null ? void 0 : C.configure({
        ...h,
        validationCallback: function(G, p) {
          i.value = {
            ...i.value,
            [G]: p
          }, Object.values(i.value).includes(!1) ? o.value = !1 : Object.values(i.value).length === 3 && (o.value = !0);
        },
        timeoutCallback: function() {
          d(L.NMI_SDK_LOAD_ERROR);
        },
        fieldsAvailableCallback: function() {
          r(Y.PAYMENT_CALLBACK, {
            type: oe.READY,
            value: !0,
            provider: Z.NMI
          }), a.value = !1;
        },
        callback: (G) => {
          H(G.token);
        }
      }));
    };
    function m() {
      if (!o.value)
        return d(L.INVALID_CARD_DETAILS), !1;
      if (n.showBillingFields) {
        const S = f.value.validateBillingDetails();
        return S === !0 ? !0 : (d(S), !1);
      }
      return d(""), !0;
    }
    async function I(S) {
      var h;
      try {
        r(Y.PAYMENT_CALLBACK, {
          type: oe.PROCESSING,
          value: !0,
          provider: Z.NMI
        }), c.value = S, (h = window == null ? void 0 : window.CollectJS) == null || h.startPaymentRequest();
      } catch (C) {
        return d(C.message || L.SOMETHING_WENT_WRONG), !1;
      }
    }
    async function H(S) {
      try {
        const { source: h } = c.value;
        if (h === V.UPDATE_PAYMENT_METHOD) {
          const G = await N(S, c.value);
          return r(Y.PAYMENT_CALLBACK, {
            type: oe.SUCCESS,
            data: G,
            provider: Z.NMI
          }), !0;
        }
        const C = await R(S, c.value);
        return r(Y.PAYMENT_CALLBACK, {
          type: oe.SUCCESS,
          data: C,
          provider: Z.NMI
        }), !0;
      } catch (h) {
        const C = Ye(h);
        return d(C || h.message || L.SOMETHING_WENT_WRONG), !1;
      }
    }
    async function N(S, h) {
      const { env: C, altId: G, altType: p } = n, { contactId: E, token: v, liveMode: B } = h, M = `${fe[C]}/nmi/recurring/payment-method`, A = {
        altId: G,
        paymentToken: S,
        contactId: E,
        token: v,
        liveMode: B
      }, { data: T } = await ae.put(M, A, {});
      if (!T.success)
        throw new Error(T.message);
      return T;
    }
    async function R(S, h) {
      const { source: C } = h;
      if (C === V.ORDER)
        return await await x(S, h);
      if (C === V.INVOICE)
        return await k(S, h);
      if ([
        V.MANUAL,
        V.FORM,
        V.SURVEY
      ].includes(C))
        return await $(S, h);
      throw new Error(L.INVALID_PAYMENT_SOURCE);
    }
    async function x(S, h) {
      const { env: C, altId: G, altType: p } = n, { sourceId: E } = h, v = (h == null ? void 0 : h.traceId) || n.traceId, B = `${fe[C]}/nmi/order/pay`, M = {
        ...h == null ? void 0 : h.extra,
        altId: G,
        altType: p,
        orderId: E,
        paymentToken: S
      };
      if (n.showBillingFields) {
        const D = {
          pincode: u.value,
          countryCode: s.value
        };
        M.billingInfo = D;
      }
      const A = {};
      v && (A["x-parent-trace-context"] = v);
      const { data: T } = await ae.post(B, M, { headers: A });
      if (!T.success)
        throw new Error(T.message);
      return T;
    }
    async function k(S, h) {
      const { env: C, altId: G, altType: p } = n, { sourceId: E } = h, v = (h == null ? void 0 : h.traceId) || n.traceId, B = `${gt[C]}/nmi/payment`, M = {
        ...h == null ? void 0 : h.extra,
        altId: G,
        altType: p,
        invoiceId: E,
        paymentToken: S
      }, A = {};
      v && (A["x-parent-trace-context"] = v);
      const { data: T } = await ae.post(B, M, { headers: A });
      if (!T.success)
        throw new Error(T.message);
      return T;
    }
    async function $(S, h) {
      const { env: C, altId: G, altType: p } = n, { source: E, sourceId: v } = h, B = (h == null ? void 0 : h.traceId) || n.traceId, M = `${fe[C]}/nmi/pay-public`, A = {
        ...h == null ? void 0 : h.extra,
        altId: G,
        altType: p,
        liveMode: n.liveMode,
        source: E,
        sourceId: v,
        paymentToken: S
      }, T = {};
      B && (T["x-parent-trace-context"] = B);
      const { data: D } = await ae.post(M, A, { headers: T });
      if (!D.success)
        throw new Error(D.message);
      return D;
    }
    return t({
      validatePayment: m,
      confirmPayment: I,
      updatePaymentMethod: N
    }), (S, h) => (K(), ue(je, null, [
      e.showModeBadge && !a.value ? (K(), Ne(St, {
        key: 0,
        liveMode: e.liveMode
      }, null, 8, ["liveMode"])) : de("", !0),
      ke(Nt, null, {
        default: lt(() => [
          q("div", null, [
            a.value ? de("", !0) : (K(), ue("label", Da, "Card Number")),
            q("div", {
              id: `ccnumber-${e.id}`
            }, null, 8, La)
          ]),
          q("div", Ua, [
            q("div", null, [
              a.value ? de("", !0) : (K(), ue("label", Fa, "Expiration")),
              q("div", {
                id: `ccexp-${e.id}`
              }, null, 8, qa)
            ]),
            q("div", null, [
              a.value ? de("", !0) : (K(), ue("label", $a, "CVC")),
              q("div", {
                id: `cvv-${e.id}`
              }, null, 8, Ga)
            ])
          ])
        ]),
        _: 1
      }),
      !a.value && e.showBillingFields ? (K(), ue("div", Va, [
        ke(vn, {
          enableBillingInfo: e.showBillingFields,
          pincode: u.value,
          "onUpdate:pincode": h[0] || (h[0] = (C) => u.value = C),
          countryCode: s.value,
          "onUpdate:countryCode": h[1] || (h[1] = (C) => s.value = C),
          ref_key: "UIBillingElementRef",
          ref: f
        }, null, 8, ["enableBillingInfo", "pincode", "countryCode"])
      ])) : de("", !0)
    ], 64));
  }
});
var st = {}, Ya = {
  get exports() {
    return st;
  },
  set exports(e) {
    st = e;
  }
}, Ct = {};
Object.defineProperty(Ct, "__esModule", { value: !0 });
function $e(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? $e = function(t) {
    return typeof t;
  } : $e = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, $e(e);
}
var gn = "https://js.stripe.com/v3", Ha = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/, Kt = "loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used", ja = function() {
  for (var t = document.querySelectorAll('script[src^="'.concat(gn, '"]')), r = 0; r < t.length; r++) {
    var n = t[r];
    if (Ha.test(n.src))
      return n;
  }
  return null;
}, za = function(t) {
  var r = t && !t.advancedFraudSignals ? "?advancedFraudSignals=false" : "", n = document.createElement("script");
  n.src = "".concat(gn).concat(r);
  var a = document.head || document.body;
  if (!a)
    throw new Error("Expected document.body not to be null. Stripe.js requires a <body> element.");
  return a.appendChild(n), n;
}, Wa = function(t, r) {
  !t || !t._registerWrapper || t._registerWrapper({
    name: "stripe-js",
    version: "1.50.0",
    startTime: r
  });
}, xe = null, Ja = function(t) {
  return xe !== null || (xe = new Promise(function(r, n) {
    if (typeof window > "u" || typeof document > "u") {
      r(null);
      return;
    }
    if (window.Stripe && t && console.warn(Kt), window.Stripe) {
      r(window.Stripe);
      return;
    }
    try {
      var a = ja();
      a && t ? console.warn(Kt) : a || (a = za(t)), a.addEventListener("load", function() {
        window.Stripe ? r(window.Stripe) : n(new Error("Stripe.js not available"));
      }), a.addEventListener("error", function() {
        n(new Error("Failed to load Stripe.js"));
      });
    } catch (o) {
      n(o);
      return;
    }
  })), xe;
}, Za = function(t, r, n) {
  if (t === null)
    return null;
  var a = t.apply(void 0, r);
  return Wa(a, n), a;
}, Yt = function(t) {
  var r = `invalid load parameters; expected object of shape

    {advancedFraudSignals: boolean}

but received

    `.concat(JSON.stringify(t), `
`);
  if (t === null || $e(t) !== "object")
    throw new Error(r);
  if (Object.keys(t).length === 1 && typeof t.advancedFraudSignals == "boolean")
    return t;
  throw new Error(r);
}, Ge, ct = !1, Nn = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  ct = !0;
  var a = Date.now();
  return Ja(Ge).then(function(o) {
    return Za(o, r, a);
  });
};
Nn.setLoadParameters = function(e) {
  if (ct && Ge) {
    var t = Yt(e), r = Object.keys(t), n = r.reduce(function(a, o) {
      var i;
      return a && e[o] === ((i = Ge) === null || i === void 0 ? void 0 : i[o]);
    }, !0);
    if (n)
      return;
  }
  if (ct)
    throw new Error("You cannot change load parameters after calling loadStripe");
  Ge = Yt(e);
};
Ct.loadStripe = Nn;
(function(e) {
  e.exports = Ct;
})(Ya);
/*!
 * currency.js - v2.0.4
 * http://scurker.github.io/currency.js
 *
 * Copyright (c) 2021 Jason Wilson
 * Released under MIT license
 */
var Xa = {
  symbol: "$",
  separator: ",",
  decimal: ".",
  errorOnInvalid: !1,
  precision: 2,
  pattern: "!#",
  negativePattern: "-!#",
  format: no,
  fromCents: !1
}, In = function(t) {
  return Math.round(t);
}, Ot = function(t) {
  return Math.pow(10, t);
}, Qa = function(t, r) {
  return In(t / r) * r;
}, eo = /(\d)(?=(\d{3})+\b)/g, to = /(\d)(?=(\d\d)+\d\b)/g;
function pe(e, t) {
  var r = this;
  if (!(r instanceof pe))
    return new pe(e, t);
  var n = Object.assign({}, Xa, t), a = Ot(n.precision), o = Ve(e, n);
  r.intValue = o, r.value = o / a, n.increment = n.increment || 1 / a, n.useVedic ? n.groups = to : n.groups = eo, this.s = n, this.p = a;
}
function Ve(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, n = 0, a = t.decimal, o = t.errorOnInvalid, i = t.precision, c = t.fromCents, u = Ot(i), s = typeof e == "number", f = e instanceof pe;
  if (f && c)
    return e.intValue;
  if (s || f)
    n = f ? e.value : e;
  else if (typeof e == "string") {
    var d = new RegExp("[^-\\d" + a + "]", "g"), O = new RegExp("\\" + a, "g");
    n = e.replace(/\((.*)\)/, "-$1").replace(d, "").replace(O, "."), n = n || 0;
  } else {
    if (o)
      throw Error("Invalid Input");
    n = 0;
  }
  return c || (n *= u, n = n.toFixed(4)), r ? In(n) : n;
}
function no(e, t) {
  var r = t.pattern, n = t.negativePattern, a = t.symbol, o = t.separator, i = t.decimal, c = t.groups, u = ("" + e).replace(/^-/, "").split("."), s = u[0], f = u[1];
  return (e.value >= 0 ? r : n).replace("!", a).replace("#", s.replace(c, "$1" + o) + (f ? i + f : ""));
}
pe.prototype = {
  /**
   * Adds values together.
   * @param {number} number
   * @returns {currency}
   */
  add: function(t) {
    var r = this.intValue, n = this.s, a = this.p;
    return pe((r += Ve(t, n)) / (n.fromCents ? 1 : a), n);
  },
  /**
   * Subtracts value.
   * @param {number} number
   * @returns {currency}
   */
  subtract: function(t) {
    var r = this.intValue, n = this.s, a = this.p;
    return pe((r -= Ve(t, n)) / (n.fromCents ? 1 : a), n);
  },
  /**
   * Multiplies values.
   * @param {number} number
   * @returns {currency}
   */
  multiply: function(t) {
    var r = this.intValue, n = this.s;
    return pe((r *= t) / (n.fromCents ? 1 : Ot(n.precision)), n);
  },
  /**
   * Divides value.
   * @param {number} number
   * @returns {currency}
   */
  divide: function(t) {
    var r = this.intValue, n = this.s;
    return pe(r /= Ve(t, n, !1), n);
  },
  /**
   * Takes the currency amount and distributes the values evenly. Any extra pennies
   * left over from the distribution will be stacked onto the first set of entries.
   * @param {number} count
   * @returns {array}
   */
  distribute: function(t) {
    for (var r = this.intValue, n = this.p, a = this.s, o = [], i = Math[r >= 0 ? "floor" : "ceil"](r / t), c = Math.abs(r - i * t), u = a.fromCents ? 1 : n; t !== 0; t--) {
      var s = pe(i / u, a);
      c-- > 0 && (s = s[r >= 0 ? "add" : "subtract"](1 / u)), o.push(s);
    }
    return o;
  },
  /**
   * Returns the dollar value.
   * @returns {number}
   */
  dollars: function() {
    return ~~this.value;
  },
  /**
   * Returns the cent value.
   * @returns {number}
   */
  cents: function() {
    var t = this.intValue, r = this.p;
    return ~~(t % r);
  },
  /**
   * Formats the value as a string according to the formatting settings.
   * @param {boolean} useSymbol - format with currency symbol
   * @returns {string}
   */
  format: function(t) {
    var r = this.s;
    return typeof t == "function" ? t(this, r) : r.format(this, Object.assign({}, r, t));
  },
  /**
   * Formats the value as a string according to the formatting settings.
   * @returns {string}
   */
  toString: function() {
    var t = this.intValue, r = this.p, n = this.s;
    return Qa(t / r, n.increment).toFixed(n.precision);
  },
  /**
   * Value for JSON serialization.
   * @returns {float}
   */
  toJSON: function() {
    return this.value;
  }
};
const ro = ["id"], ao = {
  name: "UIStripePaymentElement",
  inheritAttrs: !1
}, oo = /* @__PURE__ */ Ie({
  ...ao,
  props: {
    env: {
      type: String,
      required: !0
    },
    id: {
      type: String,
      required: !0
    },
    altId: {
      type: String,
      required: !0
    },
    altType: {
      type: String,
      required: !0
    },
    liveMode: {
      type: Boolean,
      required: !0
    },
    showModeBadge: {
      type: Boolean,
      required: !1,
      default: !0
    },
    debug: {
      type: Boolean,
      required: !1,
      default: !1
    },
    traceId: {
      type: String,
      required: !1
    },
    publishableKey: {
      type: String,
      required: !0
    },
    accountId: {
      type: String,
      required: !0
    },
    stripeOptions: {
      type: Object,
      required: !0
    },
    stripeMinimumChargeAmount: {
      type: Object,
      required: !0
    },
    stripeZeroDecimalCurrencies: {
      type: Object,
      required: !0
    }
  },
  emits: [Y.PAYMENT_CALLBACK],
  setup(e, { expose: t, emit: r }) {
    const n = e, a = (p, E) => {
      var v;
      return (v = n.stripeZeroDecimalCurrencies) != null && v.includes(E == null ? void 0 : E.toUpperCase()) ? pe(p, { precision: 0 }).value : pe(p).multiply(100).value;
    }, o = _(), i = _(), c = _(), u = _(), s = (p) => {
      r(Y.PAYMENT_CALLBACK, {
        type: oe.ERROR,
        message: p,
        provider: Z.STRIPE
      });
    };
    be(() => f());
    async function f() {
      if (await d(), !o.value)
        return;
      const p = O();
      await b(p);
    }
    async function d() {
      const { publishableKey: p, accountId: E } = n, v = await st.loadStripe(p, {
        stripeAccount: E || void 0
      });
      if (!v) {
        s(L.STRIPE_SDK_LOAD_ERROR);
        return;
      }
      return o.value = v, v;
    }
    function O() {
      const {
        mode: p,
        currency: E,
        paymentMethodConfiguration: v,
        paymentMethodOptions: B,
        enableBNPL: M
      } = n.stripeOptions;
      let { amount: A } = n.stripeOptions, T = "automatic";
      return A === 0 && (T = "manual", A = 1, n.stripeMinimumChargeAmount && (A = n.stripeMinimumChargeAmount[E == null ? void 0 : E.toUpperCase()] || 1)), {
        mode: p,
        amount: a(A, E),
        currency: E,
        setupFutureUsage: M ? void 0 : "off_session",
        captureMethod: T,
        payment_method_configuration: v,
        payment_method_options: B
      };
    }
    async function b(p) {
      var B, M, A;
      const E = o.value.elements(p);
      i.value = E;
      let v = {
        applePay: "never",
        auBecsDebit: "never",
        bancontact: "never",
        card: "never",
        cashapp: "never",
        googlePay: "never",
        ideal: "never",
        paypal: "never",
        sepaDebit: "never",
        sofort: "never",
        usBankAccount: "never"
      };
      if ((B = n.stripeOptions) != null && B.terms && (v = (M = n.stripeOptions) == null ? void 0 : M.terms), c.value = E.create("payment", {
        layout: (A = n.stripeOptions) == null ? void 0 : A.layout,
        terms: v
      }), !c.value) {
        s(L.STRIPE_PAYMENT_ELEMENT_CREATE_ERROR);
        return;
      }
      c.value.mount(`#${n.id}`), c.value.on("ready", function() {
        r(Y.PAYMENT_CALLBACK, {
          type: oe.READY,
          value: !0,
          provider: Z.STRIPE
        });
      }), c.value.on("loaderror", function(T) {
        s(L.STRIPE_PAYMENT_ELEMENT_LOAD_ERROR);
      }), c.value.on("change", function(T) {
        var D;
        u.value = (D = T.value) == null ? void 0 : D.type;
      });
    }
    He(n.stripeOptions, () => {
      const p = O();
      if (n.debug, !i.value)
        return b(p);
      i.value.update(p);
    });
    async function m() {
      const { error: p } = await i.value.submit();
      return p ? (s(p == null ? void 0 : p.message), !1) : (s(""), !0);
    }
    async function I(p) {
      try {
        if (r(Y.PAYMENT_CALLBACK, {
          type: oe.PROCESSING,
          value: !0,
          provider: Z.STRIPE
        }), n.stripeOptions.enableBNPL && !["affirm", "klarna", "afterpay_clearpay", "zip"].includes(
          u.value
        )) {
          const A = O();
          A.setupFutureUsage = "off_session", i.value.update(A);
        }
        const E = await N(p), { clientSecret: v } = E;
        if (!await H(
          v,
          p
        ))
          return !1;
        const M = await $(p, E);
        return r(Y.PAYMENT_CALLBACK, {
          type: oe.SUCCESS,
          data: M,
          provider: Z.STRIPE
        }), !0;
      } catch (E) {
        const v = Ye(E);
        return s(
          v || E.message || L.SOMETHING_WENT_WRONG_IN_CONFIRMING_PAYMENT
        ), !1;
      }
    }
    async function H(p, E) {
      var M;
      const v = window.location.href.indexOf("?") !== -1 ? "&" : "?", B = await o.value.confirmPayment({
        elements: i.value,
        clientSecret: p,
        redirect: "if_required",
        confirmParams: {
          return_url: `${window.location.href}${v}sourceId=${E == null ? void 0 : E.sourceId}&altId=${n.altId}`
        }
      });
      return B.error ? B.error.type === zr.VALIDATION_ERROR ? (s(""), !1) : (s(
        ((M = B.error) == null ? void 0 : M.message) || L.FAILED_TO_CONFIRM_PAYMENT
      ), !1) : !0;
    }
    async function N(p) {
      try {
        const { source: E } = p;
        let v;
        if (E === V.ORDER)
          v = await R(p);
        else if (E === V.INVOICE)
          v = await x(p);
        else if ([
          V.MANUAL,
          V.FORM,
          V.SURVEY
        ].includes(E))
          v = await k(p);
        else
          throw new Error(L.INVALID_PAYMENT_SOURCE);
        if (!v.success)
          throw new Error(v.message);
        return v;
      } catch (E) {
        const v = Ye(E);
        throw new Error(
          v || E.message || L.SOMETHING_WENT_WRONG_IN_INITIATE_PAYMENT
        );
      }
    }
    async function R(p) {
      const { env: E, altId: v, altType: B, stripeOptions: M } = n, { paymentMethodConfiguration: A, paymentMethodOptions: T } = M, { sourceId: D, captchaToken: Q } = p, j = (p == null ? void 0 : p.traceId) || n.traceId, z = `${fe[E]}/stripe/initiate`, W = {
        altId: v,
        altType: B,
        orderId: D,
        paymentMethodConfiguration: A,
        paymentMethodOptions: T,
        captchaToken: Q
      };
      ["affirm", "klarna", "afterpay_clearpay", "zip"].includes(
        u.value
      ) && (W.clearFutureUsage = !0);
      const ie = {};
      j && (ie["x-parent-trace-context"] = j);
      const { data: Ee } = await ae.post(z, W, { headers: ie });
      return Ee;
    }
    async function x(p) {
      const { env: E, altId: v, altType: B, stripeOptions: M } = n, { paymentMethodConfiguration: A, paymentMethodOptions: T } = M, { sourceId: D } = p, Q = (p == null ? void 0 : p.traceId) || (n == null ? void 0 : n.traceId), j = `${fe[E]}/stripe/invoice/initiate`, z = {
        altId: v,
        altType: B,
        invoiceId: D,
        paymentMethodConfiguration: A,
        paymentMethodOptions: T
      }, W = {};
      Q && (W["x-parent-trace-context"] = Q);
      const { data: ie } = await ae.post(j, z, { headers: W });
      return ie;
    }
    async function k(p) {
      const { env: E, altId: v, altType: B, stripeOptions: M } = n, { paymentMethodConfiguration: A, paymentMethodOptions: T } = M, { source: D, sourceId: Q } = p, j = (p == null ? void 0 : p.traceId) || (n == null ? void 0 : n.traceId), z = `${fe[E]}/stripe/initiate-general-payment-public`, W = {
        ...p == null ? void 0 : p.extra,
        altId: v,
        altType: B,
        liveMode: n.liveMode,
        source: D,
        sourceId: Q,
        paymentMethodConfiguration: A,
        paymentMethodOptions: T
      }, ie = {};
      j && (ie["x-parent-trace-context"] = j);
      const { data: Ee } = await ae.post(z, W, { headers: ie });
      return Ee;
    }
    async function $(p, E) {
      const { source: v } = p;
      if (v === V.ORDER)
        return await S(p, E);
      if (v === V.INVOICE)
        return await h(p, E);
      if ([
        V.MANUAL,
        V.FORM,
        V.SURVEY
      ].includes(v))
        return await C(p, E);
      throw new Error(L.INVALID_PAYMENT_SOURCE);
    }
    async function S(p, E) {
      const { env: v, altId: B, altType: M } = n, { sourceId: A } = p, T = `${fe[v]}/stripe/verify`, { subscriptionId: D, invoiceId: Q, paymentIntentId: j, isAuth: z, traceId: W } = E, ie = {
        ...p == null ? void 0 : p.extra,
        altId: B,
        altType: M,
        orderId: A,
        subscriptionId: D,
        invoiceId: Q,
        paymentIntentId: j,
        isAuth: z
      }, Ee = {};
      W && (Ee["x-parent-trace-context"] = W);
      const { data: _e } = await ae.post(T, ie, { headers: Ee });
      if (!_e.success)
        throw new Error(_e.message);
      return _e;
    }
    async function h(p, E) {
      const { env: v, altId: B, altType: M } = n, { sourceId: A } = p, T = `${gt[v]}/verify-payment`, { txnId: D, traceId: Q } = E, j = {
        ...p == null ? void 0 : p.extra,
        altId: B,
        altType: M,
        invoiceId: A,
        internalTxnId: D
      }, z = {};
      Q && (z["x-parent-trace-context"] = Q);
      const { data: W } = await ae.post(T, j, { headers: z });
      if (!W.success)
        throw new Error(W.message);
      return W;
    }
    async function C(p, E) {
      const { env: v, altId: B, altType: M } = n, A = `${fe[v]}/stripe/verify-general-payment`, { transactionId: T, traceId: D } = E, Q = {
        altId: B,
        altType: M,
        transactionId: T
      }, j = {};
      D && (j["x-parent-trace-context"] = D);
      const { data: z } = await ae.post(A, Q, { headers: j });
      if (!z.success)
        throw new Error(z.message);
      return z;
    }
    Bn(() => G());
    function G() {
      if (c.value)
        try {
          c.value.destroy();
        } catch {
        }
    }
    return t({
      validatePayment: m,
      confirmPayment: I
    }), (p, E) => (K(), ue(je, null, [
      e.showModeBadge && c.value ? (K(), Ne(St, {
        key: 0,
        liveMode: e.liveMode
      }, null, 8, ["liveMode"])) : de("", !0),
      Pn(q("div", { id: e.id }, null, 8, ro), [
        [xn, c.value]
      ])
    ], 64));
  }
}), io = { class: "ghl-payment-element" }, so = {
  name: "UIPaymentElement",
  inheritAttrs: !1
}, co = /* @__PURE__ */ Ie({
  ...so,
  props: {
    env: {
      type: String,
      required: !0
    },
    id: {
      type: String,
      required: !0
    },
    altId: {
      type: String,
      required: !0
    },
    altType: {
      type: String,
      required: !0
    },
    liveMode: {
      type: Boolean,
      required: !0
    },
    showModeBadge: {
      type: Boolean,
      required: !1,
      default: !0
    },
    debug: {
      type: Boolean,
      required: !1,
      default: !1
    },
    traceId: {
      type: String,
      required: !1
    },
    stripeOptions: {
      type: Object,
      required: !1
    },
    showBillingFields: {
      type: Boolean,
      required: !1,
      default: !1
    },
    updatePaymentMethod: {
      type: Boolean,
      required: !1,
      default: !1
    },
    paymentProvider: {
      type: String,
      required: !1
    }
  },
  emits: [Y.PAYMENT_CALLBACK],
  setup(e, { expose: t, emit: r }) {
    const n = e, a = _(), o = _(), i = _(), c = _();
    function u(N) {
      r(Y.PAYMENT_CALLBACK, {
        type: oe.ERROR,
        message: N
      });
    }
    be(async () => {
      const N = await s();
      N && f(N);
    });
    async function s() {
      const { env: N, liveMode: R, altId: x, altType: k, traceId: $ } = n;
      if (!(![!0, !1].includes(R) || !x || !k))
        try {
          const S = {};
          $ && (S["x-parent-trace-context"] = $);
          const { data: h } = await ae.get(
            `${fe[N]}/integrations/public`,
            {
              params: {
                altId: x,
                altType: k,
                liveMode: R
              },
              headers: S
            }
          );
          return h;
        } catch (S) {
          u(
            S.message || L.SOMETHING_WENT_WRONG_IN_FETCHING_PAYMENT_INTEGRATIONS
          );
        }
    }
    function f(N) {
      let { defaultPaymentProvider: R } = N;
      if (n.updatePaymentMethod && n.paymentProvider && (R = n.paymentProvider), !R)
        return u(L.PAYMENT_PROVIDER_NOT_FOUND);
      R === Z.STRIPE ? d(N.stripe) : R === Z.NMI ? O(N.nmi) : R === Z.AUTHORIZE_NET && b(N.authorizeNet);
    }
    function d(N) {
      const {
        publishableKey: R,
        accountId: x,
        stripeMinimumChargeAmount: k,
        stripeZeroDecimalCurrencies: $
      } = N;
      if (!R)
        return u(L.STRIPE_CONNECTION_NOT_FOUND);
      a.value = {
        stripe: {
          show: !0,
          publishableKey: R,
          accountId: x,
          stripeMinimumChargeAmount: k,
          stripeZeroDecimalCurrencies: $
        }
      };
    }
    function O(N) {
      const { merchantPublicKey: R } = N;
      if (!R)
        return u(L.NMI_CONNECTION_NOT_FOUND);
      a.value = {
        nmi: {
          show: !0,
          merchantPublicKey: R
        }
      };
    }
    function b(N) {
      const { merchantLoginId: R, merchantPublicClientKey: x } = N;
      if (!R || !x)
        return u(L.AUTHORIZE_NET_CONNECTION_NOT_FOUND);
      a.value = {
        authorizeNet: {
          show: !0,
          merchantLoginId: R,
          merchantPublicClientKey: x
        }
      };
    }
    function m(N) {
      r(Y.PAYMENT_CALLBACK, N);
    }
    async function I() {
      const { stripe: N, nmi: R, authorizeNet: x } = a.value || {};
      return N != null && N.show ? await o.value.validatePayment() : R != null && R.show ? await i.value.validatePayment() : x != null && x.show ? await c.value.validatePayment() : (u(L.PAYMENT_PROVIDER_NOT_FOUND), !1);
    }
    async function H(N) {
      const { stripe: R, nmi: x, authorizeNet: k } = a.value || {};
      return R != null && R.show ? await o.value.confirmPayment(N) : x != null && x.show ? await i.value.confirmPayment(N) : k != null && k.show ? await c.value.confirmPayment(N) : (u(L.PAYMENT_PROVIDER_NOT_FOUND), !1);
    }
    return t({
      validatePayment: I,
      confirmPayment: H
    }), (N, R) => {
      var x, k, $, S, h, C, G, p, E, v, B, M, A, T, D, Q, j, z, W, ie;
      return K(), ue("div", io, [
        e.stripeOptions && ((k = (x = a.value) == null ? void 0 : x.stripe) != null && k.show) ? (K(), Ne(oo, {
          key: 0,
          ref_key: "stripePaymentElement",
          ref: o,
          env: e.env,
          id: e.id,
          altId: e.altId,
          altType: e.altType,
          liveMode: e.liveMode,
          showModeBadge: e.showModeBadge,
          debug: e.debug,
          publishableKey: (S = ($ = a.value) == null ? void 0 : $.stripe) == null ? void 0 : S.publishableKey,
          accountId: (C = (h = a.value) == null ? void 0 : h.stripe) == null ? void 0 : C.accountId,
          stripeOptions: e.stripeOptions,
          onPaymentCallback: m,
          stripeMinimumChargeAmount: (p = (G = a.value) == null ? void 0 : G.stripe) == null ? void 0 : p.stripeMinimumChargeAmount,
          stripeZeroDecimalCurrencies: (v = (E = a.value) == null ? void 0 : E.stripe) == null ? void 0 : v.stripeZeroDecimalCurrencies
        }, null, 8, ["env", "id", "altId", "altType", "liveMode", "showModeBadge", "debug", "publishableKey", "accountId", "stripeOptions", "stripeMinimumChargeAmount", "stripeZeroDecimalCurrencies"])) : de("", !0),
        (M = (B = a.value) == null ? void 0 : B.nmi) != null && M.show ? (K(), Ne(Ka, {
          key: 1,
          ref_key: "nmiCardElement",
          ref: i,
          env: e.env,
          id: e.id,
          altId: e.altId,
          altType: e.altType,
          liveMode: e.liveMode,
          showModeBadge: e.showModeBadge,
          debug: e.debug,
          merchantPublicKey: (T = (A = a.value) == null ? void 0 : A.nmi) == null ? void 0 : T.merchantPublicKey,
          onPaymentCallback: m,
          showBillingFields: e.showBillingFields
        }, null, 8, ["env", "id", "altId", "altType", "liveMode", "showModeBadge", "debug", "merchantPublicKey", "showBillingFields"])) : de("", !0),
        (Q = (D = a.value) == null ? void 0 : D.authorizeNet) != null && Q.show ? (K(), Ne(xa, {
          key: 2,
          ref_key: "authorizeNetCardElement",
          ref: c,
          env: e.env,
          id: e.id,
          altId: e.altId,
          altType: e.altType,
          liveMode: e.liveMode,
          showModeBadge: e.showModeBadge,
          debug: e.debug,
          merchantLoginId: (z = (j = a.value) == null ? void 0 : j.authorizeNet) == null ? void 0 : z.merchantLoginId,
          merchantPublicClientKey: (ie = (W = a.value) == null ? void 0 : W.authorizeNet) == null ? void 0 : ie.merchantPublicClientKey,
          onPaymentCallback: m,
          showBillingFields: e.showBillingFields
        }, null, 8, ["env", "id", "altId", "altType", "liveMode", "showModeBadge", "debug", "merchantLoginId", "merchantPublicClientKey", "showBillingFields"])) : de("", !0)
      ]);
    };
  }
}), nt = {
  UIPaymentElement: co
};
function lo(e) {
  for (const t in nt)
    e.component(nt[t].name, nt[t]);
}
const fo = { install: lo };
export {
  co as UIPaymentElement,
  fo as default
};
